'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _throttle = require('lodash/throttle');
(function () {
  var TECHNIC_NORMAL_INDEX = 0x12; //18
  var RELEASE_VERSION = 4;
  var SERIAL_INTERVAL = 32;
  var EVENT_INTERVAL = 16;
  var SEND_PACKET_LENGTH = 22;
  var RECEIVED_PACKET_LENGTH = 17;
  Entry.ProboTechnicNormalLite = new (/*#__PURE__*/function () {
    function ProboTechnicNormalLite() {
      var _this = this;
      (0, _classCallCheck2["default"])(this, ProboTechnicNormalLite);
      this.id = '630301';
      this.name = 'ProboTechnicNormalLite';
      this.url = 'https://imssam.me';
      this.imageName = 'alux_technic_normal_lite.png';
      this.title = {
        ko: '프로보 테크닉(일반)',
        en: 'Probo Technic(Normal)'
      };
      this.portData = {
        baudRate: 115200,
        duration: this.SERIAL_INTERVAL,
        dataBits: 8,
        parity: 'none',
        stopBits: 1,
        bufferSize: 128,
        connectionType: 'bytestream',
        constantServing: 'ReadOnly'
      };
      this.Color = {
        Red: {
          Min: 13,
          Max: 37
        },
        Green: {
          Min: 38,
          Max: 62
        },
        Blue: {
          Min: 63,
          Max: 87
        },
        Yellow: {
          Min: 88,
          Max: 112
        },
        Black: {
          Min: 113,
          Max: 137
        },
        White: {
          Min: 138,
          Max: 162
        }
      };
      this.MultiSwitch = {
        Key1: {
          Min: 1,
          Max: 19
        },
        Key2: {
          Min: 26,
          Max: 44
        },
        Key3: {
          Min: 53,
          Max: 77
        },
        Key4: {
          Min: 83,
          Max: 101
        },
        Key5: {
          Min: 107,
          Max: 125
        },
        Key6: {
          Min: 139,
          Max: 157
        },
        Key7: {
          Min: 160,
          Max: 178
        },
        Key8: {
          Min: 191,
          Max: 209
        }
      };
      this.Note = {
        n32: 48,
        // = 1*3*4*4,
        n16: 96,
        // = 2*3*4*4,
        n16d: 144,
        // = 3*3*4*4,
        n16t: 64,
        // = 2*2*4*4,
        n8: 192,
        // = 4*3*4*4,
        n8d: 288,
        // = 6*3*4*4,
        n8t: 128,
        // = 4*2*4*4,
        n4: 384,
        // = 8*3*4*4,
        n4d: 576,
        // = 12*3*4*4,
        n4t: 256,
        // = 8*2*4*4,
        n2: 768,
        // = 16*3*4*4,
        n2d: 1152,
        // = 24*3*4*4,
        n2t: 512,
        // = 16*2*4*4,
        n1: 1536 // = 32*3*4*4
      };
      this.Rgb = {
        Off: 0,
        On: {
          Red: 1,
          Yellow: 12,
          Green: 23,
          Cyan: 34,
          Blue: 45,
          Magenta: 56,
          White: 67
        },
        Dimming: {
          Red: 90,
          Yellow: 91,
          Green: 92,
          Cyan: 93,
          Blue: 94,
          Magenta: 95,
          White: 96
        }
      };
      this.Melody = [0, 35391, 33405, 31530, 29760, 28090, 26513, 25025, 23621, 22295, 21044, 19863, 18748];
      this.Track = [[0x451F, 0x3D95, 0x36DD, 0x33C8, 0x2E22, 0x291A, 0x249E],
      // Start : size 7,
      [0x228F, 0x249E, 0x291A, 0x2E22, 0x33C8, 0x36DD, 0x3D95, 0x451F],
      // End : size 8,
      [0x228F, 0x1B6E, 0x1711, 0x1147],
      // LevelUp : size 4,
      [0x1147, 0x1711, 0x1B6E, 0x228F] // LevelDwon : size 4,
      ];
      var eventSetting = {
        leading: true,
        trailing: false
      };
      this.remoteEvent = _throttle(function () {
        var prevFlag = _this.sendFlag;
        try {
          Entry.engine.fireEvent('technicnormallite_event_remote_input');
        } catch (e) {} finally {
          _this.sendFlag = prevFlag;
        }
      }, EVENT_INTERVAL, eventSetting);
      this.digitalEvent = _throttle(function () {
        var prevFlag = _this.sendFlag;
        try {
          Entry.engine.fireEvent('technicnormallite_event_digital_input');
        } catch (e) {} finally {
          _this.sendFlag = prevFlag;
        }
      }, EVENT_INTERVAL, eventSetting);
      this.qRear = 0;
      this.qFront = 0;
      this.qSize = 128;
      this.qBuffer = new Uint8Array(this.qSize + 2).fill(-1);
      this.inputPacket = new Uint8Array(RECEIVED_PACKET_LENGTH).fill(-1);
      this.pLength = 0; // packet length
      this.process = false; // packet process

      this.version = 0;
      this.sendFlag = true;
      this.blockMenuBlocks = [
      //dropdown
      'technicnormallite_dropdown_remote_key', 'technicnormallite_dropdown_digital_key', 'technicnormallite_dropdown_analog_key', 'technicnormallite_dropdown_setting_sensor_key', 'technicnormallite_dropdown_inNcom_sensor_key', 'technicnormallite_dropdown_sensor_color_key', 'technicnormallite_dropdown_rgb_color_key', 'technicnormallite_dropdown_sensor_angle_key', 'technicnormallite_dropdown_multikey_key', 'technicnormallite_dropdown_extension_digital_key', 'technicnormallite_dropdown_extension_analog_key', 'technicnormallite_dropdown_dc_1_all_key', 'technicnormallite_dropdown_port_1_4_key', 'technicnormallite_dropdown_on_off_key', 'technicnormallite_dropdown_velocity_key', 'technicnormallite_dropdown_servo_position_key', 'technicnormallite_dropdown_note_key', 'technicnormallite_dropdown_time_1_key', 'technicnormallite_dropdown_time_2_key', 'technicnormallite_dropdown_time_3', 'technicnormallite_dropdown_pitch_key', 'technicnormallite_dropdown_melody_key',
      //event
      'technicnormallite_when_press_remote_key', 'technicnormallite_when_input_digital_value',
      //setting
      'technicnormallite_set_senser_setting',
      //input
      'technicnormallite_is_remote_key', 'technicnormallite_is_digital_value', 'technicnormallite_is_extension_digital_input', 'technicnormallite_get_analog_value', 'technicnormallite_get_extension_analog_input',
      // 'technicnormallite_get_tri_axis_acceler_x', // 테크닉 에서 사용하지 않음
      // 'technicnormallite_get_tri_axis_acceler_y', // 테크닉 에서 사용하지 않음
      // 'technicnormallite_get_tri_axis_acceler_z', // 테크닉 에서 사용하지 않음
      'technicnormallite_get_value_mapping', 'technicnormallite_is_color_value', 'technicnormallite_get_color_value', 'technicnormallite_set_infinite_setting', 'technicnormallite_get_infinite_mm_diameter', 'technicnormallite_get_infinite_transform_input',
      // 'technicnormallite_is_multi_sensor', // 테크닉 에서 사용하지 않음
      // 'technicnormallite_is_multi_switch', // 테크닉 에서 사용하지 않음
      'technicnormallite_set_eeprom_call', 'technicnormallite_get_eeprom_address_value',
      //output
      'technicnormallite_set_dc_output', 'technicnormallite_set_servo_output',
      // 'technicnormallite_set_s_dc_output', // 테크닉 에서 사용하지 않음
      'technicnormallite_set_port_output', 'technicnormallite_play_melody_note_output', 'technicnormallite_play_melody_sec_output', 'technicnormallite_play_melody_output', 'technicnormallite_play_value_sec_output', 'technicnormallite_play_value_output', 'technicnormallite_play_melody_track_output', 'technicnormallite_play_melody_off', 'technicnormallite_set_rgbled_on_output', 'technicnormallite_set_rgbled_off_output', 'technicnormallite_set_rgbled_flashing_output', 'technicnormallite_set_rgbled_dimming_output',
      // 'technicnormallite_set_fnd_output', // 테크닉 에서 사용하지 않음
      // 'technicnormallite_set_fnd_off',    // 테크닉 에서 사용하지 않음

      //EEPROM
      'technicnormallite_set_eeprom_write'];
    }
    return (0, _createClass2["default"])(ProboTechnicNormalLite, [{
      key: "setLanguage",
      value: function setLanguage() {
        return {
          ko: {
            template: {
              technicnormallite_item_switch: '스위치',
              technicnormallite_item_infrared: '적외선',
              technicnormallite_item_magnetic: '자석',
              technicnormallite_item_rotation: '회전',
              technicnormallite_item_color: '컬러',
              technicnormallite_item_acceleration: '가속도',
              technicnormallite_item_ultrasonic: '초음파',
              technicnormallite_item_heart_rate: '심박',
              technicnormallite_item_illuminance: '조도',
              technicnormallite_item_temperature: '온도',
              technicnormallite_item_sound: '소리',
              technicnormallite_item_tilt: '기울기',
              technicnormallite_item_pressure: '압력',
              technicnormallite_item_multi_touch: '멀티키',
              technicnormallite_item_compass: '나침반',
              technicnormallite_item_tri_acceleration: '3가속',
              technicnormallite_item_multi_switch: '분배기',
              technicnormallite_item_infinite_rotation: '무한회전',
              technicnormallite_item_extension_input: '확장입력',
              technicnormallite_item_color_red: '빨간색',
              technicnormallite_item_color_green: '초록색',
              technicnormallite_item_color_blue: '파란색',
              technicnormallite_item_color_cyan: '청녹색',
              technicnormallite_item_color_magenta: '자홍색',
              technicnormallite_item_color_yellow: '노란색',
              technicnormallite_item_color_black: '검정색',
              technicnormallite_item_color_white: '하얀색',
              technicnormallite_item_value: '값',
              technicnormallite_item_angle: '각도',
              technicnormallite_item_absolute_angle: '절대각도',
              technicnormallite_item_number_of_rotations: '회전 수',
              technicnormallite_item_key_1: '키1',
              technicnormallite_item_key_2: '키2',
              technicnormallite_item_key_3: '키3',
              technicnormallite_item_key_4: '키4',
              technicnormallite_item_key_5: '키5',
              technicnormallite_item_key_6: '키6',
              technicnormallite_item_key_7: '키7',
              technicnormallite_item_key_8: '키8',
              technicnormallite_item_all: '모두',
              technicnormallite_item_on: '켜기',
              technicnormallite_item_off: '끄기',
              technicnormallite_item_note_whole: '온',
              technicnormallite_item_note_half: '2분',
              technicnormallite_item_note_quarter: '4분',
              technicnormallite_item_note_eighth: '8분',
              technicnormallite_item_note_sixteenth: '16분',
              technicnormallite_item_note_thirty_second: '32분',
              technicnormallite_item_pitch_do: '도',
              technicnormallite_item_pitch_do_sharp: '도#',
              technicnormallite_item_pitch_re: '레',
              technicnormallite_item_pitch_re_sharp: '레#',
              technicnormallite_item_pitch_mi: '미',
              technicnormallite_item_pitch_fa: '파',
              technicnormallite_item_pitch_fa_sharp: '파#',
              technicnormallite_item_pitch_sol: '솔',
              technicnormallite_item_pitch_sol_sharp: '솔#',
              technicnormallite_item_pitch_ra: '라',
              technicnormallite_item_pitch_ra_sharp: '라#',
              technicnormallite_item_pitch_si: '시',
              technicnormallite_item_melody_start: '시작음',
              technicnormallite_item_melody_end: '종료음',
              technicnormallite_item_melody_level_up: '레벨 업',
              technicnormallite_item_melody_level_down: '레벨 다운',
              technicnormallite_item_error: '오류',
              technicnormallite_item_nothing: '없음',
              technicnormallite_when_press_remote_key: '%1 리모컨 %2 키를 눌렀을 때',
              technicnormallite_when_input_digital_value: '%1 디지털 입력 %2 이(가) 들어왔을 때',
              technicnormallite_set_senser_setting: '입력포트 %1 을(를) %2 센서로 설정 %3',
              technicnormallite_is_remote_key: '리모컨 입력 %1',
              technicnormallite_is_digital_value: '디지털 입력 %1',
              technicnormallite_is_extension_digital_input: '확장 디지털 입력 %1 의 %2',
              technicnormallite_get_analog_value: '아날로그 입력 %1',
              technicnormallite_get_extension_analog_input: '확장 아날로그 입력 %1 의 %2',
              technicnormallite_get_tri_axis_acceler_x: '3가속도 %1의 X축',
              technicnormallite_get_tri_axis_acceler_y: '3가속도 %1의 Y축',
              technicnormallite_get_tri_axis_acceler_z: '3가속도 %1의 Z축',
              technicnormallite_get_value_mapping: '%1 의 %2 ~ %3 값을 %4 ~ %5 (으)로 변환',
              technicnormallite_is_color_value: '컬러 센서 %1 이(가) %2 인가?',
              technicnormallite_get_color_value: '컬러 센서 %1 의 색상',
              technicnormallite_set_infinite_setting: '%1 센서 %2 을 %3 값으로 정하기 %4',
              technicnormallite_get_infinite_mm_diameter: '%1 센서 %2 지름 %3 의 mm 값',
              technicnormallite_get_infinite_transform_input: '%1 센서 %2 의  %3',
              technicnormallite_is_multi_sensor: '멀티키 센서 %1의 %2',
              technicnormallite_is_multi_switch: '분배 스위치 %1의 %2',
              technicnormallite_set_eeprom_call: 'EEPROM %1 주소의 값 호출하기 %2',
              technicnormallite_get_eeprom_address_value: 'EEPROM 주소의 값',
              technicnormallite_set_port_output: '출력핀 %1 을(를) %2 %3',
              technicnormallite_set_servo_output: '서보 모터 %1 의 위치를 %2 로 이동 %3',
              technicnormallite_set_s_dc_output: 'S 모터 %1 을(를) %2 속도로 회전 %3',
              technicnormallite_set_dc_output: 'DC 모터 %1 을(를) %2 속도로 회전 %3',
              technicnormallite_play_melody_note_output: '%1 을(를) %2 음표로 연주하기 %3',
              technicnormallite_play_melody_sec_output: '%1 을(를) %2 초 동안 연주하기 %3',
              technicnormallite_play_melody_output: '%1 을(를) 연주하기 %2',
              technicnormallite_play_value_sec_output: '%1 값을(를) %2 초 동안 연주하기 %3',
              technicnormallite_play_value_output: '%1 값을(를) 연주하기 %2',
              technicnormallite_play_melody_track_output: '%1 을(를) %2초 간격으로 재생하기 %3',
              technicnormallite_play_melody_off: '멜로디 중지 %1',
              technicnormallite_set_rgbled_on_output: 'RGB LED %1 을(를) %2 으로 켜기 %3',
              technicnormallite_set_rgbled_off_output: 'RGB LED %1 을(를) 끄기 %2',
              technicnormallite_set_rgbled_dimming_output: 'RGB LED %1 을(를) %2 으로 디밍 %3',
              technicnormallite_set_rgbled_flashing_output: 'RGB LED %1 %2 으로 %3 초 간격 %4',
              technicnormallite_set_fnd_output: 'FND를 %1 (으)로 설정 %2',
              technicnormallite_set_fnd_off: 'FND 끄기 %1',
              technicnormallite_set_eeprom_write: 'EEPROM %1 주소에 %2 값 설정하기 %3'
            },
            Device: {
              probo_technic_normal: '프로보 테크닉(일반)'
            },
            Menus: {
              probo_technic_normal_lite: '프로보 테크닉(일반)'
            }
          },
          en: {
            template: {
              technicnormallite_item_switch: 'Switch',
              technicnormallite_item_infrared: 'Infrared',
              technicnormallite_item_magnetic: 'Magnetic',
              technicnormallite_item_rotation: 'Rotation',
              technicnormallite_item_color: 'Color',
              technicnormallite_item_acceleration: 'Acceleration',
              technicnormallite_item_ultrasonic: 'Ultrasonic',
              technicnormallite_item_heart_rate: 'Heart Rate',
              technicnormallite_item_illuminance: 'Illuminance',
              technicnormallite_item_temperature: 'Temperature',
              technicnormallite_item_sound: 'Sound',
              technicnormallite_item_tilt: 'Tilt',
              technicnormallite_item_pressure: 'Pressure',
              technicnormallite_item_multi_touch: 'Multi Touch',
              technicnormallite_item_compass: 'Compass',
              technicnormallite_item_tri_acceleration: '3Acceleration',
              technicnormallite_item_multi_switch: 'Multi Switch',
              technicnormallite_item_infinite_rotation: 'Infinite Rotation',
              technicnormallite_item_extension_input: 'Extension Input',
              technicnormallite_item_color_red: 'Red',
              technicnormallite_item_color_green: 'Green',
              technicnormallite_item_color_blue: 'Blue',
              technicnormallite_item_color_cyan: 'Cyan',
              technicnormallite_item_color_magenta: 'Magenta',
              technicnormallite_item_color_yellow: 'Yellow',
              technicnormallite_item_color_black: 'Black',
              technicnormallite_item_color_white: 'White',
              technicnormallite_item_value: 'Value',
              technicnormallite_item_angle: 'Angle',
              technicnormallite_item_absolute_angle: 'Absolute Angle',
              technicnormallite_item_number_of_rotations: 'Number of Rotations',
              technicnormallite_item_key_1: 'Key1',
              technicnormallite_item_key_2: 'Key2',
              technicnormallite_item_key_3: 'Key3',
              technicnormallite_item_key_4: 'Key4',
              technicnormallite_item_key_5: 'Key5',
              technicnormallite_item_key_6: 'Key6',
              technicnormallite_item_key_7: 'Key7',
              technicnormallite_item_key_8: 'Key8',
              technicnormallite_item_all: 'All',
              technicnormallite_item_on: 'On',
              technicnormallite_item_off: 'Off',
              technicnormallite_item_note_whole: 'Whole',
              technicnormallite_item_note_half: 'Half',
              technicnormallite_item_note_quarter: 'Quarter',
              technicnormallite_item_note_eighth: 'Eighth',
              technicnormallite_item_note_sixteenth: 'Sixteenth',
              technicnormallite_item_note_thirty_second: 'Thirty-Second',
              technicnormallite_item_pitch_do: 'do',
              technicnormallite_item_pitch_do_sharp: 'xdo',
              technicnormallite_item_pitch_re: 're',
              technicnormallite_item_pitch_re_sharp: 'xre',
              technicnormallite_item_pitch_mi: 'mi',
              technicnormallite_item_pitch_fa: 'fa',
              technicnormallite_item_pitch_fa_sharp: 'xfa',
              technicnormallite_item_pitch_sol: 'sol',
              technicnormallite_item_pitch_sol_sharp: 'xsol',
              technicnormallite_item_pitch_ra: 'ra',
              technicnormallite_item_pitch_ra_sharp: 'xra',
              technicnormallite_item_pitch_si: 'si',
              technicnormallite_item_melody_start: 'Start',
              technicnormallite_item_melody_end: 'End',
              technicnormallite_item_melody_level_up: 'Level up',
              technicnormallite_item_melody_level_down: 'Level down',
              technicnormallite_item_error: 'error',
              technicnormallite_item_nothing: 'nothing',
              technicnormallite_when_press_remote_key: '%1 When %2 remote control key pressed',
              technicnormallite_when_input_digital_value: '%1 When %2 digital pin input',
              technicnormallite_set_senser_setting: 'Set input port %1 to %2 sensor %3',
              technicnormallite_is_remote_key: 'Remote control %1',
              technicnormallite_is_digital_value: 'Read digital pin %1',
              technicnormallite_is_extension_digital_input: 'Extension digital input %1 to %2',
              technicnormallite_get_analog_value: 'Read analog pin %1',
              technicnormallite_get_extension_analog_input: 'Extension analog input %1 to %2',
              technicnormallite_get_tri_axis_acceler_x: '3acceleration %1 and X',
              technicnormallite_get_tri_axis_acceler_y: '3acceleration %1 and Y',
              technicnormallite_get_tri_axis_acceler_z: '3acceleration %1 and Z',
              technicnormallite_get_value_mapping: '%1 to value %2 ~ %3 change %4 ~ %5',
              technicnormallite_is_color_value: 'Is color sensor %1 %2 ?',
              technicnormallite_get_color_value: 'Color of color sensor %1',
              technicnormallite_set_infinite_setting: 'Set %1 sensor %2 to %3 value %4',
              technicnormallite_get_infinite_mm_diameter: 'The move distance(in mm) when the %1 sensor %2 is %3 mm in diameter',
              technicnormallite_get_infinite_transform_input: '%1 rotation sensor %2 to %3',
              technicnormallite_is_multi_sensor: 'Multi sensor %1 key %2',
              technicnormallite_is_multi_switch: 'A key number of the multi-switch sensor %1 = %2',
              technicnormallite_set_eeprom_call: 'Calling the value of EEPROM %1 address',
              technicnormallite_get_eeprom_address_value: 'Value of EEPROM address',
              technicnormallite_set_dc_output: 'DC motor %1 velocity %2 %3',
              technicnormallite_set_servo_output: 'Servo motor %1 position %2 %3',
              technicnormallite_set_s_dc_output: 'Servo motor %1 speed %2 %3',
              technicnormallite_set_port_output: 'Set digital pin %1 as %2 %3',
              technicnormallite_play_melody_note_output: 'Play key %1 for %2 note %3',
              technicnormallite_play_melody_sec_output: 'Play key %1 for %2 secs %3',
              technicnormallite_play_melody_output: 'Play key %1 %2',
              technicnormallite_play_value_sec_output: 'Play value %1 for %2 secs %3',
              technicnormallite_play_value_output: 'Play value %1 %2',
              technicnormallite_play_melody_track_output: 'Play sound %1 for %2 secs %3',
              technicnormallite_play_melody_off: 'Stop tone %1',
              technicnormallite_set_rgbled_on_output: 'Turn on RGB LED %1 to %2 %3',
              technicnormallite_set_rgbled_off_output: 'Turn off RGB LED %1 %2',
              technicnormallite_set_rgbled_dimming_output: 'Dimming RGB LED %1 to %2 %3',
              technicnormallite_set_rgbled_flashing_output: 'RGB LED %1 Blinking %2 at %3 second intervals %4',
              technicnormallite_set_fnd_output: 'Set FND to %1 %2',
              technicnormallite_set_fnd_off: 'Turn off FND %1',
              technicnormallite_set_eeprom_write: 'Set EEPROM %1 address to %2 %3'
            },
            Device: {
              probo_technic_normal_lite: 'Probo Technic(Normal)'
            },
            Menus: {
              probo_technic_normal_lite: 'Probo Technic(Normal)'
            }
          }
        };
      }

      // 시작하기 및 정지하기 시 기기상태를 초기화한다.
    }, {
      key: "setZero",
      value: function setZero() {
        this.Infinite = {
          Buff: {
            AA1: 0,
            AA2: 0,
            AA3: 0,
            AA4: 0
          },
          Count: {
            AA1: 0,
            AA2: 0,
            AA3: 0,
            AA4: 0
          },
          Start: {
            AA1: 0,
            AA2: 0,
            AA3: 0,
            AA4: 0
          }
        };
        this.SenserSet = {
          AA1: 0,
          AA2: 0,
          AA3: 0,
          AA4: 0
        };
        this.InputData = {
          Analog: {
            AA1: 0,
            AA2: 0,
            AA3: 0,
            AA4: 0
          },
          Digital: {
            A1: 0,
            A2: 0,
            A3: 0,
            A4: 0,
            FEA1: 0,
            FEA2: 0,
            FEA3: 0,
            FEA4: 0,
            REA1: 0,
            REA2: 0,
            REA3: 0,
            REA4: 0,
            BEA1: 0,
            BEA2: 0,
            BEA3: 0,
            BEA4: 0
          },
          Remote: {
            R_1: 0,
            R_2: 0,
            R_3: 0,
            R_4: 0,
            R_5: 0,
            R_6: 0,
            R_7: 0,
            R_8: 0,
            R_L1: 0,
            R_L2: 0,
            R_R1: 0,
            R_R2: 0
          },
          EEPROM: {
            EC: 0,
            EEPR2: 0,
            EEPR1: 0
          },
          Infinite: {
            ROTATION_1: 0,
            ROTATION_2: 0,
            ROTATION_3: 0,
            ROTATION_4: 0
          },
          Acceler: {
            AXIS_X1: 0,
            AXIS_X2: 0,
            AXIS_X3: 0,
            AXIS_X4: 0,
            AXIS_Y1: 0,
            AXIS_Y2: 0,
            AXIS_Y3: 0,
            AXIS_Y4: 0,
            AXIS_Z1: 0,
            AXIS_Z2: 0,
            AXIS_Z3: 0,
            AXIS_Z4: 0
          }
        };
        this.RemoteData = {
          B1: 0,
          B2: 0,
          B3: 0,
          B4: 0,
          Servo1: 0,
          Servo2: 0,
          Servo3: 0,
          Servo4: 0,
          DC1: 0,
          DC2: 0,
          DC3: 0,
          DC4: 0,
          MEL2: 0,
          MEL1: 0,
          FND: 100,
          EEPR4: 0,
          EEPR3: 0,
          EEPR2: 0,
          EEPR1: 0,
          ASET2: 0,
          ASET1: 0
        };
        this.EdgeFlag = {
          FEA1: 0,
          FEA2: 0,
          FEA3: 0,
          FEA4: 0,
          REA1: 0,
          REA2: 0,
          REA3: 0,
          REA4: 0,
          BEA1: 0,
          BEA2: 0,
          BEA3: 0,
          BEA4: 0
        };
        this.EEPROM = {
          Buff: 0,
          Count: 0
        };
        if (Entry.hwLite && Entry.hwLite.serial) {
          Entry.hwLite.serial.update();
        }
        ;
      }

      // 하드웨어 연결 후 초기화한다.
    }, {
      key: "initialHandshake",
      value: function () {
        var _initialHandshake = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
          var _this2 = this;
          var ko, en, modePacket, response, packet, _ko, _en, version;
          return _regenerator["default"].wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                ko = "\uD14C\uD06C\uB2C9\uC758 'Start' \uBC84\uD2BC\uC744 \uB204\uB978 \uD6C4 \uD655\uC778\uC744 \uD074\uB9AD\uD558\uC138\uC694.\n";
                en = "(Please, After pushing the 'Start' button in Technic, click 'OK'.)";
                alert("".concat(ko).concat(en));
                modePacket = new Uint8Array(2).fill(0);
                modePacket[0] = 0x63;
                modePacket[1] = 0x36;
              case 1:
                if (!true) {
                  _context.next = 7;
                  break;
                }
                _context.next = 2;
                return Entry.hwLite.serial.sendAsyncWithThrottle(modePacket);
              case 2:
                response = _context.sent;
                if (!(response[0] !== TECHNIC_NORMAL_INDEX)) {
                  _context.next = 3;
                  break;
                }
                modePacket[0] = 0x24;
                modePacket[1] = 0x42;
                _context.next = 5;
                break;
              case 3:
                this.version = response.length === 1 ? RELEASE_VERSION : response[1];
                _context.next = 4;
                return Entry.Utils.sleep(1000);
              case 4:
                return _context.abrupt("continue", 7);
              case 5:
                _context.next = 6;
                return Entry.Utils.sleep(100);
              case 6:
                _context.next = 1;
                break;
              case 7:
                Entry.addEventListener('run', this.handleRemoteEventInterval.bind(this));
                Entry.addEventListener('run', this.handleDigitalEventInterval.bind(this));
                Entry.addEventListener('beforeStop', function () {
                  if (_this2.remoteEventIntervalId) {
                    clearInterval(_this2.remoteEventIntervalId);
                    _this2.remoteEventIntervalId = null;
                  }
                  if (_this2.digitalEventIntervalId) {
                    clearInterval(_this2.digitalEventIntervalId);
                    _this2.digitalEventIntervalId = null;
                  }
                });
                this.setZero();
                if (!(this.version === 0)) {
                  _context.next = 9;
                  break;
                }
                _context.next = 8;
                return Entry.hwLite.serial.reader.read();
              case 8:
                packet = _context.sent;
                this.version = packet.value[0];
                if (this.version !== RELEASE_VERSION) {
                  _ko = "\uD38C\uC6E8\uC5B4\uB97C \uC5C5\uB370\uC774\uD2B8 \uD558\uC138\uC694.\n";
                  _en = "(Please, Update your firmware.)\n";
                  version = " - \uD604\uC7AC(now): v.".concat(this.version, "\n - \uCD5C\uC2E0(latest): v.").concat(RELEASE_VERSION);
                  alert("".concat(_ko).concat(_en).concat(version));
                }
              case 9:
                return _context.abrupt("return", true);
              case 10:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function initialHandshake() {
          return _initialHandshake.apply(this, arguments);
        }
        return initialHandshake;
      }()
    }, {
      key: "handleRemoteEventInterval",
      value: function handleRemoteEventInterval() {
        var _this3 = this;
        if (this.remoteEventIntervalId) {
          clearInterval(this.remoteEventIntervalId);
        }
        this.remoteEventIntervalId = setInterval(function () {
          var currentState = _this3.remoteEvent.bind(_this3);
          currentState();
        }, EVENT_INTERVAL);
      }
    }, {
      key: "handleDigitalEventInterval",
      value: function handleDigitalEventInterval() {
        var _this4 = this;
        if (this.digitalEventIntervalId) {
          clearInterval(this.digitalEventIntervalId);
        }
        this.digitalEventIntervalId = setInterval(function () {
          var currentState = _this4.digitalEvent.bind(_this4);
          currentState();
        }, EVENT_INTERVAL);
      }

      // 디바이스에서 값을 읽어온다.
    }, {
      key: "handleLocalData",
      value: function handleLocalData(buffer) {
        var _this5 = this;
        buffer.forEach(function (b) {
          return _this5.qEnqueue(b);
        });
        if (this._recoverTimeoutId) {
          clearTimeout(this._recoverTimeoutId);
        }
        while (this.qCount() >= this.inputPacket.length) {
          if (!this.process) {
            while (this.qCount() > 0) {
              if (this.inputPacket[0] !== 0xCD) {
                this.inputPacket[0] = this.qDequeue();
              } else if (this.inputPacket[1] !== 0xDA) {
                this.inputPacket[1] = this.qDequeue();
              } else {
                this.inputPacket[2] = this.qDequeue();
                this.pLength = this.inputPacket[2] + 3;
                this.process = true;
                break;
              }
            }
          }
          if (this.process && this.qCount() >= this.pLength) {
            for (var i = 3; i < this.pLength; i++) {
              this.inputPacket[i] = this.qDequeue();
            }
            if (this.checksumHandle(this.inputPacket)) {
              this.processInputPacket(this.inputPacket);
            }
            this.inputPacket = new Uint8Array(RECEIVED_PACKET_LENGTH).fill(-1);
            this.process = false;
            this.sendFlag = true;
            this.pLength = 0;
          }
        }
        if (this.sendFlag) {
          if (this._requestTimeoutId) {
            clearTimeout(this._requestTimeoutId);
          }
          this._requestTimeoutId = setTimeout(function () {
            if (Entry.hwLite && Entry.hwLite.serial) {
              Entry.hwLite.serial.update();
              _this5.sendFlag = false;
              _this5._recoverTimeoutId = setTimeout(function () {
                _this5.sendFlag = true;
              }, SERIAL_INTERVAL * 3);
            }
          }, SERIAL_INTERVAL);
        }
        ;
      }

      //디바이스에 값을 쓴다.
    }, {
      key: "requestLocalData",
      value: function requestLocalData() {
        if (this.sendFlag) {
          return this.generateOutputPacket(this.RemoteData);
        }
      }
    }, {
      key: "qEnqueue",
      value: function qEnqueue(data) {
        this.qBuffer[this.qRear] = data;
        this.qRear = (this.qRear + 1) % this.qSize;
      }
    }, {
      key: "qDequeue",
      value: function qDequeue() {
        var data = this.qBuffer[this.qFront];
        this.qBuffer[this.qFront] = -1;
        this.qFront = (this.qFront + 1) % this.qSize;
        return data;
      }
    }, {
      key: "qCount",
      value: function qCount() {
        return this.qFront <= this.qRear ? this.qRear - this.qFront : this.qSize - this.qFront + this.qRear;
      }
    }, {
      key: "checksumRequest",
      value: function checksumRequest(packet) {
        var length = packet[2] + 2;
        var checker = 0;
        for (var i = 3; i < length; i++) {
          checker += packet[i];
        }
        return checker & 0xFF;
      }
    }, {
      key: "checksumHandle",
      value: function checksumHandle(packet) {
        var checker = 0;
        var length = packet[2] + 2;
        for (var i = 3; i < length; i++) {
          checker += packet[i];
        }
        return packet[length] === (checker & 0xFF);
      }
    }, {
      key: "processInputPacket",
      value: function processInputPacket(packet) {
        var digitalByte1 = packet[8];
        var digitalByte2 = packet[9];
        var remoteByte1 = packet[10];
        var remoteByte2 = packet[11];
        var rotationByte = packet[16];
        this.InputData.Analog.AA1 = packet[4];
        this.InputData.Analog.AA2 = packet[5];
        this.InputData.Analog.AA3 = packet[6];
        this.InputData.Analog.AA4 = packet[7];
        this.InputData.Digital.A4 = digitalByte1 >> 7 & 0x01;
        this.InputData.Digital.A3 = digitalByte1 >> 6 & 0x01;
        this.InputData.Digital.A2 = digitalByte1 >> 5 & 0x01;
        this.InputData.Digital.A1 = digitalByte1 >> 4 & 0x01;
        this.InputData.Digital.FEA4 = digitalByte1 >> 3 & 0x01;
        this.InputData.Digital.FEA3 = digitalByte1 >> 2 & 0x01;
        this.InputData.Digital.FEA2 = digitalByte1 >> 1 & 0x01;
        this.InputData.Digital.FEA1 = digitalByte1 & 0x01;
        this.InputData.Digital.REA4 = digitalByte2 >> 7 & 0x01;
        this.InputData.Digital.REA3 = digitalByte2 >> 6 & 0x01;
        this.InputData.Digital.REA2 = digitalByte2 >> 5 & 0x01;
        this.InputData.Digital.REA1 = digitalByte2 >> 4 & 0x01;
        this.InputData.Digital.BEA4 = digitalByte2 >> 3 & 0x01;
        this.InputData.Digital.BEA3 = digitalByte2 >> 2 & 0x01;
        this.InputData.Digital.BEA2 = digitalByte2 >> 1 & 0x01;
        this.InputData.Digital.BEA1 = digitalByte2 & 0x01;
        this.InputData.Remote.R_3 = remoteByte1 >> 7 & 0x01;
        this.InputData.Remote.R_2 = remoteByte1 >> 6 & 0x01;
        this.InputData.Remote.R_4 = remoteByte1 >> 5 & 0x01;
        this.InputData.Remote.R_1 = remoteByte1 >> 4 & 0x01;
        this.InputData.Remote.R_7 = remoteByte2 >> 7 & 0x01;
        this.InputData.Remote.R_6 = remoteByte2 >> 6 & 0x01;
        this.InputData.Remote.R_8 = remoteByte2 >> 5 & 0x01;
        this.InputData.Remote.R_5 = remoteByte2 >> 4 & 0x01;
        this.InputData.Remote.R_R1 = remoteByte2 >> 3 & 0x01;
        this.InputData.Remote.R_L1 = remoteByte2 >> 2 & 0x01;
        this.InputData.Remote.R_R2 = remoteByte2 >> 1 & 0x01;
        this.InputData.Remote.R_L2 = remoteByte2 & 0x01;
        this.InputData.EEPROM.EC = packet[13];
        this.InputData.EEPROM.EEPR2 = packet[14];
        this.InputData.EEPROM.EEPR1 = packet[15];
        this.InputData.Infinite.ROTATION_1 = rotationByte >> 6 & 0x0C;
        this.InputData.Infinite.ROTATION_2 = rotationByte >> 4 & 0x0C;
        this.InputData.Infinite.ROTATION_3 = rotationByte >> 2 & 0x0C;
        this.InputData.Infinite.ROTATION_4 = rotationByte & 0x03;
        this.InputData.Acceler.AXIS_X1 = packet[4];
        this.InputData.Acceler.AXIS_X2 = packet[5];
        this.InputData.Acceler.AXIS_X3 = packet[6];
        this.InputData.Acceler.AXIS_X4 = packet[7];
        this.InputData.Acceler.AXIS_Y1 = packet[17];
        this.InputData.Acceler.AXIS_Y2 = packet[19];
        this.InputData.Acceler.AXIS_Y3 = packet[21];
        this.InputData.Acceler.AXIS_Y4 = packet[23];
        this.InputData.Acceler.AXIS_Z1 = packet[18];
        this.InputData.Acceler.AXIS_Z2 = packet[20];
        this.InputData.Acceler.AXIS_Z3 = packet[22];
        this.InputData.Acceler.AXIS_Z4 = packet[24];
      }
    }, {
      key: "generateOutputPacket",
      value: function generateOutputPacket(remoteData) {
        var outputPacket = new Uint8Array(SEND_PACKET_LENGTH).fill(-1);
        outputPacket[0] = 0xAD;
        outputPacket[1] = 0xDA;
        outputPacket[2] = outputPacket.length - 3;
        outputPacket[3] = 0xF0 | remoteData.B4 << 3 | remoteData.B3 << 2 | remoteData.B2 << 1 | remoteData.B1;
        outputPacket[4] = remoteData.Servo1;
        outputPacket[5] = remoteData.Servo2;
        outputPacket[6] = remoteData.Servo3;
        outputPacket[7] = remoteData.Servo4;
        outputPacket[8] = remoteData.DC1;
        outputPacket[9] = remoteData.DC2;
        outputPacket[10] = remoteData.DC3;
        outputPacket[11] = remoteData.DC4;
        outputPacket[12] = remoteData.MEL2;
        outputPacket[13] = remoteData.MEL1;
        outputPacket[14] = remoteData.FND;
        outputPacket[15] = remoteData.EEPR4;
        outputPacket[16] = remoteData.EEPR3;
        outputPacket[17] = remoteData.EEPR2;
        outputPacket[18] = remoteData.EEPR1;
        outputPacket[19] = remoteData.ASET2;
        outputPacket[20] = remoteData.ASET1;
        outputPacket[21] = this.checksumRequest(outputPacket);
        return outputPacket;
      }
    }, {
      key: "getMonitorPort",
      value: function getMonitorPort() {
        return _objectSpread({}, this.InputData.Analog);
      }
    }, {
      key: "getRemoteKey",
      value: function getRemoteKey(data) {
        var num = Number(data);
        if (1 <= num && num <= 8) {
          return "R_".concat(num);
        } else if (9 <= num && num <= 10) {
          return "R_L".concat(num - 8);
        } else if (11 <= num && num <= 12) {
          return "R_R".concat(num - 10);
        } else {
          return data;
        }
      }
    }, {
      key: "getDigitalKey",
      value: function getDigitalKey(data) {
        var num = Number(data);
        if (1 <= num && num <= 4) {
          return "A".concat(num);
        } else if (5 <= num && num <= 8) {
          return "FEA".concat(num - 4);
        } else if (9 <= num && num <= 12) {
          return "REA".concat(num - 8);
        } else if (13 <= num && num <= 16) {
          return "BEA".concat(num - 12);
        } else {
          return data;
        }
      }
    }, {
      key: "getDigitalStateValue",
      value: function getDigitalStateValue(key) {
        var value = false;
        switch (key) {
          case 'A1':
          case 'A2':
          case 'A3':
          case 'A4':
            value = Entry.ProboTechnicNormalLite.InputData.Digital[key] === 1;
            break;
          default:
            if (Entry.ProboTechnicNormalLite.InputData.Digital[key] === 1) {
              if (Entry.ProboTechnicNormalLite.EdgeFlag[key] === 0) {
                Entry.ProboTechnicNormalLite.EdgeFlag[key] = 1;
                value = true;
              }
            } else {
              Entry.ProboTechnicNormalLite.EdgeFlag[key] = 0;
            }
            break;
        }
        return value;
      }
    }, {
      key: "getAnalogKey",
      value: function getAnalogKey(data) {
        var num = Number(data);
        if (1 <= num && num <= 4) {
          return "AA".concat(num);
        } else {
          return data;
        }
      }
    }, {
      key: "getSettingSensorValue",
      value: function getSettingSensorValue(key) {
        switch (key) {
          case '1': // 스위치
          case '2': // 적외선
          case '3': // 자석
          case '16': // 분배기
          case Lang.template.technicnormallite_item_switch: // 스위치
          case Lang.template.technicnormallite_item_infrared: // 적외선
          case Lang.template.technicnormallite_item_magnetic: // 자석
          case Lang.template.technicnormallite_item_multi_switch:
            // 분배기
            return 1;
          case '4': // 회전
          case '7': // 조도
          case '9': // 초음파
          case Lang.template.technicnormallite_item_rotation: // 회전
          case Lang.template.technicnormallite_item_illuminance: // 조도            
          case Lang.template.technicnormallite_item_ultrasonic:
            // 초음파
            return 2;
          case '10': // 소리
          case Lang.template.technicnormallite_item_sound:
            // 소리
            return 3;
          case '11': // 기울기
          case Lang.template.technicnormallite_item_tilt:
            // 기울기
            return 4;
          case '12': // 압력
          case Lang.template.technicnormallite_item_pressure:
            // 압력
            return 5;
          case '8': // 심박
          case Lang.template.technicnormallite_item_heart_rate:
            // 심박
            return 6;
          case '5': // 컬러
          case Lang.template.technicnormallite_item_color:
            // 컬러
            return 7;
          case '6': // 가속도
          case Lang.template.technicnormallite_item_acceleration:
            // 가속도
            return 8;
          case '14': // 나침반
          case '15': // 3축 가속도
          case '17': // 확장 입력  
          case Lang.template.technicnormallite_item_compass:
          case Lang.template.technicnormallite_item_tri_acceleration:
          case Lang.template.technicnormallite_item_extension_input:
            return 9;
          case '13': // 멀티터치(멀티키)
          case Lang.template.technicnormallite_item_multi_touch:
            // 멀티터치(멀티키)
            return 11;
          default:
            return key;
        }
      }
    }, {
      key: "getAxisKey",
      value: function getAxisKey(data, axis) {
        switch (data) {
          case 'AA1':
          case 'AA2':
          case 'AA3':
          case 'AA4':
            data = data.substr(2, 2);
            break;
        }
        return "AXIS_".concat(axis).concat(data);
      }
    }, {
      key: "getMultiKeyValue",
      value: function getMultiKeyValue(key) {
        var num = Number(key);
        if (1 <= num && num <= 8) {
          return num - 1;
        } else {
          switch (key) {
            case Lang.template.technicnormallite_item_key_1:
              return 0;
            case Lang.template.technicnormallite_item_key_2:
              return 1;
            case Lang.template.technicnormallite_item_key_3:
              return 2;
            case Lang.template.technicnormallite_item_key_4:
              return 3;
            case Lang.template.technicnormallite_item_key_5:
              return 4;
            case Lang.template.technicnormallite_item_key_6:
              return 5;
            case Lang.template.technicnormallite_item_key_7:
              return 6;
            case Lang.template.technicnormallite_item_key_8:
              return 7;
            default:
              return key;
          }
        }
      }
    }, {
      key: "getExtentionDigitalValue",
      value: function getExtentionDigitalValue(key) {
        var num = Number(key);
        if (1 <= num && num <= 8) {
          return num - 1;
        } else if (9 <= num && num <= 16) {
          return num - 9;
        } else {
          switch (key) {
            case 'EA1':
            case 'ET1':
              return 0;
            case 'EA2':
            case 'ET2':
              return 1;
            case 'EA3':
            case 'ET3':
              return 2;
            case 'EA4':
            case 'ET4':
              return 3;
            case 'EA5':
            case 'ET5':
              return 4;
            case 'EA6':
            case 'ET6':
              return 5;
            case 'EA7':
            case 'ET7':
              return 6;
            case 'EA8':
            case 'ET8':
              return 7;
            default:
              return key;
          }
        }
      }
    }, {
      key: "getExtentionAnalogKey",
      value: function getExtentionAnalogKey(data) {
        switch (data) {
          case '1':
          case 'EAA1':
            return 'Y';
          case '2':
          case 'EAA2':
            return 'Z';
          default:
            return data;
        }
      }
    }, {
      key: "getDckey",
      value: function getDckey(data) {
        var num = Number(data);
        if (1 <= num && num <= 7) {
          return "DC".concat(num);
        } else {
          return data;
        }
      }
    }, {
      key: "getServoKey",
      value: function getServoKey(data) {
        var num = Number(data);
        if (1 <= num && num <= 4) {
          return "Servo".concat(num);
        } else {
          return data;
        }
      }
    }, {
      key: "getPortKey",
      value: function getPortKey(data) {
        var num = Number(data);
        if (1 <= num && num <= 4) {
          return "B".concat(num);
        } else {
          return data;
        }
      }
    }, {
      key: "getPortToggleValue",
      value: function getPortToggleValue(key) {
        switch (key) {
          case '1':
          case Lang.template.technicnormallite_item_on:
            return 1;
          case '0':
          case Lang.template.technicnormallite_item_off:
            return 0;
          default:
            return key;
        }
      }
    }, {
      key: "getSensorAngleKey",
      value: function getSensorAngleKey(data) {
        switch (data) {
          case '1':
          case Lang.template.technicnormallite_item_value:
            return 'IS1';
          case '2':
          case Lang.template.technicnormallite_item_angle:
            return 'IS2';
          case '3':
          case Lang.template.technicnormallite_item_absolute_angle:
            return 'IS3';
          case '4':
          case Lang.template.technicnormallite_item_number_of_rotations:
            return 'IS4';
          default:
            return data;
        }
      }
    }, {
      key: "getPitchValue",
      value: function getPitchValue(pitch) {
        // 배열의 인덱스 1번부터 음표
        var index = pitch % 12 + 1;
        if (36 <= pitch && pitch <= 47) {
          return Entry.ProboTechnicNormalLite.Melody[index];
        } else if (48 <= pitch && pitch <= 59) {
          return Entry.ProboTechnicNormalLite.Melody[index] >> 1;
        } else if (60 <= pitch && pitch <= 71) {
          return Entry.ProboTechnicNormalLite.Melody[index] >> 2;
        } else if (72 <= pitch && pitch <= 83) {
          return Entry.ProboTechnicNormalLite.Melody[index] >> 3;
        } else {
          return Entry.ProboTechnicNormalLite.Melody[0];
        }
      }
    }, {
      key: "getNoteKey",
      value: function getNoteKey(data) {
        switch (data) {
          case '1':
          case Lang.template.technicnormallite_item_note_whole:
            return 'n1';
          case '2':
          case Lang.template.technicnormallite_item_note_half:
            return 'n2';
          case '4':
          case Lang.template.technicnormallite_item_note_quarter:
            return 'n4';
          case '8':
          case Lang.template.technicnormallite_item_note_eighth:
            return 'n8';
          case '16':
          case Lang.template.technicnormallite_item_note_sixteenth:
            return 'n16';
          case '32':
          case Lang.template.technicnormallite_item_note_thirty_second:
            return 'n32';
          default:
            return data;
        }
      }
    }, {
      key: "getMelodyValue",
      value: function getMelodyValue(key) {
        switch (key) {
          case '1':
          case Lang.template.technicnormallite_item_melody_start:
            return 0;
          case '2':
          case Lang.template.technicnormallite_item_melody_end:
            return 1;
          case '3':
          case Lang.template.technicnormallite_item_melody_level_up:
            return 2;
          case '4':
          case Lang.template.technicnormallite_item_melody_level_down:
            return 3;
          default:
            return key;
        }
      }
    }, {
      key: "getColorSensorKey",
      value: function getColorSensorKey(data) {
        switch (data) {
          case '1':
          case Lang.template.technicnormallite_item_color_red:
            return 'Red';
          case '2':
          case Lang.template.technicnormallite_item_color_green:
            return 'Green';
          case '3':
          case Lang.template.technicnormallite_item_color_blue:
            return 'Blue';
          case '4':
          case Lang.template.technicnormallite_item_color_yellow:
            return 'Yellow';
          case '5':
          case Lang.template.technicnormallite_item_color_black:
            return 'Black';
          case '6':
          case Lang.template.technicnormallite_item_color_white:
            return 'White';
          default:
            return data;
        }
      }
    }, {
      key: "getRgbToggleValue",
      value: function getRgbToggleValue(key) {
        switch (key) {
          case '0':
            return this.Rgb.Off;
          case '1':
          case Lang.template.technicnormallite_item_color_red:
            return this.Rgb.On.Red;
          case '2':
          case Lang.template.technicnormallite_item_color_green:
            return this.Rgb.On.Green;
          case '3':
          case Lang.template.technicnormallite_item_color_blue:
            return this.Rgb.On.Blue;
          case '4':
          case Lang.template.technicnormallite_item_color_cyan:
            return this.Rgb.On.Cyan;
          case '5':
          case Lang.template.technicnormallite_item_color_magenta:
            return this.Rgb.On.Magenta;
          case '6':
          case Lang.template.technicnormallite_item_color_yellow:
            return this.Rgb.On.Yellow;
          case '7':
          case Lang.template.technicnormallite_item_color_white:
            return this.Rgb.On.White;
          default:
            return key;
        }
      }
    }, {
      key: "getRgbTwinkleValue",
      value: function getRgbTwinkleValue(key, sec) {
        var twinkle = 0;
        switch (sec) {
          case 0.05:
            twinkle += 1;
            break;
          case 0.1:
            twinkle += 2;
            break;
          case 0.2:
            twinkle += 3;
            break;
          case 0.5:
            twinkle += 4;
            break;
          case 1:
            twinkle += 5;
            break;
        }
        return this.getRgbToggleValue(key) + twinkle;
      }
    }, {
      key: "getRgbDimmingValue",
      value: function getRgbDimmingValue(key) {
        switch (key) {
          case '1':
          case Lang.template.technicnormallite_item_color_red:
            return this.Rgb.Dimming.Red;
          case '2':
          case Lang.template.technicnormallite_item_color_green:
            return this.Rgb.Dimming.Green;
          case '3':
          case Lang.template.technicnormallite_item_color_blue:
            return this.Rgb.Dimming.Blue;
          case '4':
          case Lang.template.technicnormallite_item_color_cyan:
            return this.Rgb.Dimming.Cyan;
          case '5':
          case Lang.template.technicnormallite_item_color_magenta:
            return this.Rgb.Dimming.Magenta;
          case '6':
          case Lang.template.technicnormallite_item_color_yellow:
            return this.Rgb.Dimming.Yellow;
          case '7':
          case Lang.template.technicnormallite_item_color_white:
            return this.Rgb.Dimming.White;
          default:
            return key;
        }
      }
    }, {
      key: "getBlocks",
      value: function getBlocks() {
        return {
          ///========================================================================================
          /// Dropdown block
          ///========================================================================================
          technicnormallite_dropdown_remote_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['R_1', '1'], ['R_2', '2'], ['R_3', '3'], ['R_4', '4'], ['R_5', '5'], ['R_6', '6'], ['R_7', '7'], ['R_8', '8'], ['R_L1', '9'], ['R_L2', '10'], ['R_R1', '11'], ['R_R2', '12']],
              value: 1,
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringValue('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['R_1', '1'], ['R_2', '2'], ['R_3', '3'], ['R_4', '4'], ['R_5', '5'], ['R_6', '6'], ['R_7', '7'], ['R_8', '8'], ['R_L1', '9'], ['R_L2', '10'], ['R_R1', '11'], ['R_R2', '12']],
                  value: 1,
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_remote_key'
              }]
            }
          },
          technicnormallite_dropdown_digital_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['A1', '1'], ['A2', '2'], ['A3', '3'], ['A4', '4'], ['FEA1', '5'], ['FEA2', '6'], ['FEA3', '7'], ['FEA4', '8'], ['REA1', '9'], ['REA2', '10'], ['REA3', '11'], ['REA4', '12'], ['BEA1', '13'], ['BEA2', '14'], ['BEA3', '15'], ['BEA4', '16']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['A1', '1'], ['A2', '2'], ['A3', '3'], ['A4', '4'], ['FEA1', '5'], ['FEA2', '6'], ['FEA3', '7'], ['FEA4', '8'], ['REA1', '9'], ['REA2', '10'], ['REA3', '11'], ['REA4', '12'], ['BEA1', '13'], ['BEA2', '14'], ['BEA3', '15'], ['BEA4', '16']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_digital_key'
              }]
            }
          },
          technicnormallite_dropdown_analog_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['AA1', '1'], ['AA2', '2'], ['AA3', '3'], ['AA4', '4']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['AA1', '1'], ['AA2', '2'], ['AA3', '3'], ['AA4', '4']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_analog_key'
              }]
            }
          },
          technicnormallite_dropdown_setting_sensor_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [[Lang.template.technicnormallite_item_switch, '1'], [Lang.template.technicnormallite_item_infrared, '2'], [Lang.template.technicnormallite_item_magnetic, '3'], [Lang.template.technicnormallite_item_rotation, '4'], [Lang.template.technicnormallite_item_color, '5'],
              // [Lang.template.technicnormallite_item_acceleration, '6'],     // 테크닉 에서 사용하지 않음
              [Lang.template.technicnormallite_item_ultrasonic, '7'], [Lang.template.technicnormallite_item_heart_rate, '8'], [Lang.template.technicnormallite_item_illuminance, '9'], [Lang.template.technicnormallite_item_sound, '10'], [Lang.template.technicnormallite_item_tilt, '11'], [Lang.template.technicnormallite_item_pressure, '12']
              // [Lang.template.technicnormallite_item_multi_touch, '13'],      // 테크닉 에서 사용하지 않음
              // [Lang.template.technicnormallite_item_compass, '14'],          // 테크닉 에서 사용하지 않음
              // [Lang.template.technicnormallite_item_tri_acceleration, '15'], // 테크닉 에서 사용하지 않음
              // [Lang.template.technicnormallite_item_multi_switch, '16'],     // 테크닉 에서 사용하지 않음
              // [Lang.template.technicnormallite_item_extension_input, '17'], // 테크닉 에서 사용하지 않음
              ],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [[Lang.template.technicnormallite_item_switch, '1'], [Lang.template.technicnormallite_item_infrared, '2'], [Lang.template.technicnormallite_item_magnetic, '3'], [Lang.template.technicnormallite_item_rotation, '4'], [Lang.template.technicnormallite_item_color, '5'],
                  // [Lang.template.technicnormallite_item_acceleration, '6'],     // 테크닉 에서 사용하지 않음
                  [Lang.template.technicnormallite_item_ultrasonic, '7'], [Lang.template.technicnormallite_item_heart_rate, '8'], [Lang.template.technicnormallite_item_illuminance, '9'], [Lang.template.technicnormallite_item_sound, '10'], [Lang.template.technicnormallite_item_tilt, '11'], [Lang.template.technicnormallite_item_pressure, '12']
                  // [Lang.template.technicnormallite_item_multi_touch, '13'],      // 테크닉 에서 사용하지 않음
                  // [Lang.template.technicnormallite_item_compass, '14'],          // 테크닉 에서 사용하지 않음
                  // [Lang.template.technicnormallite_item_tri_acceleration, '15'], // 테크닉 에서 사용하지 않음
                  // [Lang.template.technicnormallite_item_multi_switch, '16'],     // 테크닉 에서 사용하지 않음
                  // [Lang.template.technicnormallite_item_extension_input, '17'], // 테크닉 에서 사용하지 않음
                  ],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_setting_sensor_key'
              }]
            }
          },
          technicnormallite_dropdown_inNcom_sensor_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [[Lang.template.technicnormallite_item_infinite_rotation, '1']
              //[Lang.template.technicnormallite_item_compass, '2'], // 테크닉 에서 사용하지 않음
              ],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [[Lang.template.technicnormallite_item_infinite_rotation, '1'], [Lang.template.technicnormallite_item_compass, '2']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_inNcom_sensor_key'
              }]
            }
          },
          technicnormallite_dropdown_sensor_color_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [[Lang.template.technicnormallite_item_color_red, '1'], [Lang.template.technicnormallite_item_color_green, '2'], [Lang.template.technicnormallite_item_color_blue, '3'], [Lang.template.technicnormallite_item_color_yellow, '4'], [Lang.template.technicnormallite_item_color_black, '5'], [Lang.template.technicnormallite_item_color_white, '6']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [[Lang.template.technicnormallite_item_color_red, '1'], [Lang.template.technicnormallite_item_color_green, '2'], [Lang.template.technicnormallite_item_color_blue, '3'], [Lang.template.technicnormallite_item_color_yellow, '4'], [Lang.template.technicnormallite_item_color_black, '5'], [Lang.template.technicnormallite_item_color_white, '6']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_sensor_color_key'
              }]
            }
          },
          technicnormallite_dropdown_rgb_color_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [[Lang.template.technicnormallite_item_color_red, '1'], [Lang.template.technicnormallite_item_color_green, '2'], [Lang.template.technicnormallite_item_color_blue, '3'], [Lang.template.technicnormallite_item_color_cyan, '4'], [Lang.template.technicnormallite_item_color_magenta, '5'], [Lang.template.technicnormallite_item_color_yellow, '6'], [Lang.template.technicnormallite_item_color_white, '7']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [[Lang.template.technicnormallite_item_color_red, '1'], [Lang.template.technicnormallite_item_color_green, '2'], [Lang.template.technicnormallite_item_color_blue, '3'], [Lang.template.technicnormallite_item_color_cyan, '4'], [Lang.template.technicnormallite_item_color_magenta, '5'], [Lang.template.technicnormallite_item_color_yellow, '6'], [Lang.template.technicnormallite_item_color_white, '7']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_rgb_color_key'
              }]
            }
          },
          technicnormallite_dropdown_sensor_angle_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [[Lang.template.technicnormallite_item_value, '1'], [Lang.template.technicnormallite_item_angle, '2'], [Lang.template.technicnormallite_item_absolute_angle, '3'], [Lang.template.technicnormallite_item_number_of_rotations, '4']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [[Lang.template.technicnormallite_item_value, '1'], [Lang.template.technicnormallite_item_angle, '2'], [Lang.template.technicnormallite_item_absolute_angle, '3'], [Lang.template.technicnormallite_item_number_of_rotations, '4']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_sensor_angle_key'
              }]
            }
          },
          technicnormallite_dropdown_multikey_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [[Lang.template.technicnormallite_item_key_1, '1'], [Lang.template.technicnormallite_item_key_2, '2'], [Lang.template.technicnormallite_item_key_3, '3'], [Lang.template.technicnormallite_item_key_4, '4'], [Lang.template.technicnormallite_item_key_5, '5'], [Lang.template.technicnormallite_item_key_6, '6'], [Lang.template.technicnormallite_item_key_7, '7'], [Lang.template.technicnormallite_item_key_8, '8']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [[Lang.template.technicnormallite_item_key_1, '1'], [Lang.template.technicnormallite_item_key_2, '2'], [Lang.template.technicnormallite_item_key_3, '3'], [Lang.template.technicnormallite_item_key_4, '4'], [Lang.template.technicnormallite_item_key_5, '5'], [Lang.template.technicnormallite_item_key_6, '6'], [Lang.template.technicnormallite_item_key_7, '7'], [Lang.template.technicnormallite_item_key_8, '8']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_multikey_key'
              }]
            }
          },
          technicnormallite_dropdown_extension_digital_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['EA1', '1'], ['EA2', '2'], ['EA3', '3'], ['EA4', '4'], ['EA5', '5'], ['EA6', '6'], ['EA7', '7'], ['EA8', '8'], ['ET1', '9'], ['ET2', '10'], ['ET3', '11'], ['ET4', '12'], ['ET5', '13'], ['ET6', '14'], ['ET7', '15'], ['ET8', '16']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['EA1', '1'], ['EA2', '2'], ['EA3', '3'], ['EA4', '4'], ['EA5', '5'], ['EA6', '6'], ['EA7', '7'], ['EA8', '8']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_extension_digital_key'
              }]
            }
          },
          technicnormallite_dropdown_extension_analog_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['EAA1', '1'], ['EAA2', '2']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['EAA1', '1'], ['EAA2', '2']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_extension_analog_key'
              }]
            }
          },
          technicnormallite_dropdown_dc_1_all_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['1,2', '5'], ['3,4', '6'], [Lang.template.technicnormallite_item_all, '7']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'], ['1,2', '5'], ['3,4', '6'], [Lang.template.technicnormallite_item_all, '7']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_dc_1_all_key'
              }]
            }
          },
          technicnormallite_dropdown_velocity_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['20', '20'], ['15', '15'], ['10', '10'], ['5', '5'], ['0', '0'], ['-5', '-5'], ['-10', '-10'], ['-15', '-15'], ['-20', '-20']],
              value: '0',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['20', '20'], ['15', '15'], ['10', '10'], ['5', '5'], ['0', '0'], ['-5', '-5'], ['-10', '-10'], ['-15', '-15'], ['-20', '-20']],
                  value: '0',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_velocity_key'
              }]
            }
          },
          technicnormallite_dropdown_servo_position_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['1', '1'], ['20', '20'], ['40', '40'], ['60', '60'], ['80', '80'], ['100', '100']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['1', '1'], ['20', '20'], ['40', '40'], ['60', '60'], ['80', '80'], ['100', '100']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_servo_position_key'
              }]
            }
          },
          technicnormallite_dropdown_port_1_4_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['1', '1'], ['2', '2'], ['3', '3'], ['4', '4']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['1', '1'], ['2', '2'], ['3', '3'], ['4', '4']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_port_1_4_key'
              }]
            }
          },
          technicnormallite_dropdown_on_off_key: (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [[Lang.template.technicnormallite_item_on, '1'], [Lang.template.technicnormallite_item_off, '0']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            }
          }, "events", {}), "func", function func(sprite, script) {
            return script.getStringField('PARAM0');
          }), "syntax", {
            js: [],
            py: [{
              syntax: '%1',
              blockType: 'param',
              textParams: [{
                type: 'Dropdown',
                options: [[Lang.template.technicnormallite_item_on, '1'], [Lang.template.technicnormallite_item_off, '0']],
                value: '1',
                fontSize: 11,
                bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                converter: Entry.block.converters.returnStringValue
              }],
              keyOption: 'technicnormallite_dropdown_on_off_key'
            }]
          }),
          technicnormallite_dropdown_note_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [[Lang.template.technicnormallite_item_note_whole, '1'], [Lang.template.technicnormallite_item_note_half, '2'], [Lang.template.technicnormallite_item_note_quarter, '4'], [Lang.template.technicnormallite_item_note_eighth, '8'], [Lang.template.technicnormallite_item_note_sixteenth, '16'], [Lang.template.technicnormallite_item_note_thirty_second, '32']],
              value: '4',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [[Lang.template.technicnormallite_item_note_whole, '1'], [Lang.template.technicnormallite_item_note_half, '2'], [Lang.template.technicnormallite_item_note_quarter, '4'], [Lang.template.technicnormallite_item_note_eighth, '8'], [Lang.template.technicnormallite_item_note_sixteenth, '16'], [Lang.template.technicnormallite_item_note_thirty_second, '32']],
                  value: '4',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_note_key'
              }]
            }
          },
          technicnormallite_dropdown_time_1_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['0.1', '0.1'], ['0.3', '0.3'], ['0.5', '0.5'], ['0.7', '0.7'], ['1', '1'], ['2', '2']],
              value: '0.5',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['0.1', '0.1'], ['0.3', '0.3'], ['0.5', '0.5'], ['0.7', '0.7'], ['1', '1'], ['2', '2']],
                  value: '0.5',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_time_1_key'
              }]
            }
          },
          technicnormallite_dropdown_time_2_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['0.1', '0.1'], ['0.3', '0.3'], ['0.5', '0.5'], ['0.7', '0.7'], ['1', '1'], ['2', '2']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['0.1', '0.1'], ['0.3', '0.3'], ['0.5', '0.5'], ['0.7', '0.7'], ['1', '1'], ['2', '2']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_time_2_key'
              }]
            }
          },
          technicnormallite_dropdown_time_3: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [['0.05', '0.05'], ['0.1', '0.1'], ['0.2', '0.2'], ['0.5', '0.5'], ['1', '1']],
              value: '0.5',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [['0.05', '0.05'], ['0.1', '0.1'], ['0.2', '0.2'], ['0.5', '0.5'], ['1', '1']],
                  value: '0.5',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_time_3'
              }]
            }
          },
          technicnormallite_dropdown_pitch_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'DropdownExtra',
              options: [[Lang.template.technicnormallite_item_pitch_do + ' (36)', '36'], [Lang.template.technicnormallite_item_pitch_do_sharp + ' (37)', '37'], [Lang.template.technicnormallite_item_pitch_re + ' (38)', '38'], [Lang.template.technicnormallite_item_pitch_re_sharp + ' (39)', '39'], [Lang.template.technicnormallite_item_pitch_mi + ' (40)', '40'], [Lang.template.technicnormallite_item_pitch_fa + ' (41)', '41'], [Lang.template.technicnormallite_item_pitch_fa_sharp + ' (42)', '42'], [Lang.template.technicnormallite_item_pitch_sol + ' (43)', '43'], [Lang.template.technicnormallite_item_pitch_sol_sharp + ' (44)', '44'], [Lang.template.technicnormallite_item_pitch_ra + ' (45)', '45'], [Lang.template.technicnormallite_item_pitch_ra_sharp + ' (46)', '46'], [Lang.template.technicnormallite_item_pitch_si + ' (47)', '47'], [Lang.template.technicnormallite_item_pitch_do + ' (48)', '48'], [Lang.template.technicnormallite_item_pitch_do_sharp + ' (49)', '49'], [Lang.template.technicnormallite_item_pitch_re + ' (50)', '50'], [Lang.template.technicnormallite_item_pitch_re_sharp + ' (51)', '51'], [Lang.template.technicnormallite_item_pitch_mi + ' (52)', '52'], [Lang.template.technicnormallite_item_pitch_fa + ' (53)', '53'], [Lang.template.technicnormallite_item_pitch_fa_sharp + ' (54)', '54'], [Lang.template.technicnormallite_item_pitch_sol + ' (55)', '55'], [Lang.template.technicnormallite_item_pitch_sol_sharp + ' (56)', '56'], [Lang.template.technicnormallite_item_pitch_ra + ' (57)', '57'], [Lang.template.technicnormallite_item_pitch_ra_sharp + ' (58)', '58'], [Lang.template.technicnormallite_item_pitch_si + ' (59)', '59'], [Lang.template.technicnormallite_item_pitch_do + ' (60)', '60'], [Lang.template.technicnormallite_item_pitch_do_sharp + ' (61)', '61'], [Lang.template.technicnormallite_item_pitch_re + ' (62)', '62'], [Lang.template.technicnormallite_item_pitch_re_sharp + ' (63)', '63'], [Lang.template.technicnormallite_item_pitch_mi + ' (64)', '64'], [Lang.template.technicnormallite_item_pitch_fa + ' (65)', '65'], [Lang.template.technicnormallite_item_pitch_fa_sharp + ' (66)', '66'], [Lang.template.technicnormallite_item_pitch_sol + ' (67)', '67'], [Lang.template.technicnormallite_item_pitch_sol_sharp + ' (68)', '68'], [Lang.template.technicnormallite_item_pitch_ra + ' (69)', '69'], [Lang.template.technicnormallite_item_pitch_ra_sharp + ' (70)', '70'], [Lang.template.technicnormallite_item_pitch_si + ' (71)', '71'], [Lang.template.technicnormallite_item_pitch_do + ' (72)', '72'], [Lang.template.technicnormallite_item_pitch_do_sharp + ' (73)', '73'], [Lang.template.technicnormallite_item_pitch_re + ' (74)', '74'], [Lang.template.technicnormallite_item_pitch_re_sharp + ' (75)', '75'], [Lang.template.technicnormallite_item_pitch_mi + ' (76)', '76'], [Lang.template.technicnormallite_item_pitch_fa + ' (77)', '77'], [Lang.template.technicnormallite_item_pitch_fa_sharp + ' (78)', '78'], [Lang.template.technicnormallite_item_pitch_sol + ' (79)', '79'], [Lang.template.technicnormallite_item_pitch_sol_sharp + ' (80)', '80'], [Lang.template.technicnormallite_item_pitch_ra + ' (81)', '81'], [Lang.template.technicnormallite_item_pitch_ra_sharp + ' (82)', '82'], [Lang.template.technicnormallite_item_pitch_si + ' (83)', '83']],
              value: '60',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              var value = script.getStringField('PARAM0');
              return value;
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [[Lang.template.technicnormallite_item_pitch_do + ' (36)', '36'], [Lang.template.technicnormallite_item_pitch_do_sharp + ' (37)', '37'], [Lang.template.technicnormallite_item_pitch_re + ' (38)', '38'], [Lang.template.technicnormallite_item_pitch_re_sharp + ' (39)', '39'], [Lang.template.technicnormallite_item_pitch_mi + ' (40)', '40'], [Lang.template.technicnormallite_item_pitch_fa + ' (41)', '41'], [Lang.template.technicnormallite_item_pitch_fa_sharp + ' (42)', '42'], [Lang.template.technicnormallite_item_pitch_sol + ' (43)', '43'], [Lang.template.technicnormallite_item_pitch_sol_sharp + ' (44)', '44'], [Lang.template.technicnormallite_item_pitch_ra + ' (45)', '45'], [Lang.template.technicnormallite_item_pitch_ra_sharp + ' (46)', '46'], [Lang.template.technicnormallite_item_pitch_si + ' (47)', '47'], [Lang.template.technicnormallite_item_pitch_do + ' (48)', '48'], [Lang.template.technicnormallite_item_pitch_do_sharp + ' (49)', '49'], [Lang.template.technicnormallite_item_pitch_re + ' (50)', '50'], [Lang.template.technicnormallite_item_pitch_re_sharp + ' (51)', '51'], [Lang.template.technicnormallite_item_pitch_mi + ' (52)', '52'], [Lang.template.technicnormallite_item_pitch_fa + ' (53)', '53'], [Lang.template.technicnormallite_item_pitch_fa_sharp + ' (54)', '54'], [Lang.template.technicnormallite_item_pitch_sol + ' (55)', '55'], [Lang.template.technicnormallite_item_pitch_sol_sharp + ' (56)', '56'], [Lang.template.technicnormallite_item_pitch_ra + ' (57)', '57'], [Lang.template.technicnormallite_item_pitch_ra_sharp + ' (58)', '58'], [Lang.template.technicnormallite_item_pitch_si + ' (59)', '59'], [Lang.template.technicnormallite_item_pitch_do + ' (60)', '60'], [Lang.template.technicnormallite_item_pitch_do_sharp + ' (61)', '61'], [Lang.template.technicnormallite_item_pitch_re + ' (62)', '62'], [Lang.template.technicnormallite_item_pitch_re_sharp + ' (63)', '63'], [Lang.template.technicnormallite_item_pitch_mi + ' (64)', '64'], [Lang.template.technicnormallite_item_pitch_fa + ' (65)', '65'], [Lang.template.technicnormallite_item_pitch_fa_sharp + ' (66)', '66'], [Lang.template.technicnormallite_item_pitch_sol + ' (67)', '67'], [Lang.template.technicnormallite_item_pitch_sol_sharp + ' (68)', '68'], [Lang.template.technicnormallite_item_pitch_ra + ' (69)', '69'], [Lang.template.technicnormallite_item_pitch_ra_sharp + ' (70)', '70'], [Lang.template.technicnormallite_item_pitch_si + ' (71)', '71'], [Lang.template.technicnormallite_item_pitch_do + ' (72)', '72'], [Lang.template.technicnormallite_item_pitch_do_sharp + ' (73)', '73'], [Lang.template.technicnormallite_item_pitch_re + ' (74)', '74'], [Lang.template.technicnormallite_item_pitch_re_sharp + ' (75)', '75'], [Lang.template.technicnormallite_item_pitch_mi + ' (76)', '76'], [Lang.template.technicnormallite_item_pitch_fa + ' (77)', '77'], [Lang.template.technicnormallite_item_pitch_fa_sharp + ' (78)', '78'], [Lang.template.technicnormallite_item_pitch_sol + ' (79)', '79'], [Lang.template.technicnormallite_item_pitch_sol_sharp + ' (80)', '80'], [Lang.template.technicnormallite_item_pitch_ra + ' (81)', '81'], [Lang.template.technicnormallite_item_pitch_ra_sharp + ' (82)', '82'], [Lang.template.technicnormallite_item_pitch_si + ' (83)', '83']],
                  value: '60',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_pitch_key'
              }]
            }
          },
          technicnormallite_dropdown_melody_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            skeleton: 'basic_string_field',
            statements: [],
            template: '%1',
            params: [{
              type: 'Dropdown',
              options: [[Lang.template.technicnormallite_item_melody_start, '1'], [Lang.template.technicnormallite_item_melody_end, '2'], [Lang.template.technicnormallite_item_melody_level_up, '3'], [Lang.template.technicnormallite_item_melody_level_down, '4']],
              value: '1',
              fontSize: 11,
              bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
              arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE
            }],
            events: {},
            def: {
              params: [null]
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            func: function func(sprite, script) {
              return script.getStringField('PARAM0');
            },
            syntax: {
              js: [],
              py: [{
                syntax: '%1',
                blockType: 'param',
                textParams: [{
                  type: 'Dropdown',
                  options: [[Lang.template.technicnormallite_item_melody_start, '1'], [Lang.template.technicnormallite_item_melody_end, '2'], [Lang.template.technicnormallite_item_melody_level_up, '3'], [Lang.template.technicnormallite_item_melody_level_down, '4']],
                  value: '1',
                  fontSize: 11,
                  bgColor: EntryStatic.colorSet.block.darken.HARDWARE,
                  arrowColor: EntryStatic.colorSet.arrow["default"].HARDWARE,
                  converter: Entry.block.converters.returnStringValue
                }],
                keyOption: 'technicnormallite_dropdown_melody_key'
              }]
            }
          },
          ///========================================================================================
          /// Event block
          ///========================================================================================                
          // %1 리모컨 %2 키를 눌렀을 때
          technicnormallite_when_press_remote_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_event',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/start_icon_hardwarelite.svg',
              size: 14,
              position: {
                x: 0,
                y: -2
              }
            }, {
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [null, {
                type: 'technicnormallite_dropdown_remote_key'
              }],
              type: 'technicnormallite_when_press_remote_key'
            },
            paramsKeyMap: {
              PARAM1: 1
            },
            "class": 'technicnormallite_event',
            isNotFor: ['ProboTechnicNormalLite'],
            event: 'technicnormallite_event_remote_input',
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getRemoteKey(script.getStringValue('PARAM1'));
              return Entry.ProboTechnicNormalLite.InputData.Remote[key] === 1 ? script.callReturn() : this.die();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.when_press_remote_key(%2)',
                blockType: 'event',
                passTest: true,
                textParams: [undefined, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 디지털 입력 %2 이(가) 들어왔을 때
          technicnormallite_when_input_digital_value: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_event',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/start_icon_hardwarelite.svg',
              size: 14,
              position: {
                x: 0,
                y: -2
              }
            }, {
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [null, {
                type: 'technicnormallite_dropdown_digital_key'
              }],
              type: 'technicnormallite_when_input_digital_value'
            },
            paramsKeyMap: {
              PARAM1: 1
            },
            "class": 'technicnormallite_event',
            isNotFor: ['ProboTechnicNormalLite'],
            event: 'technicnormallite_event_digital_input',
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getDigitalKey(script.getStringValue('PARAM1'));
              var value = Entry.ProboTechnicNormalLite.getDigitalStateValue(key);
              return value ? script.callReturn() : this.die();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.when_input_digital_value(%2)',
                blockType: 'event',
                passTest: true,
                textParams: [undefined, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          ///========================================================================================
          /// Setting Block
          ///========================================================================================               
          // 입력포트 %1 을(를) %2 센서로 설정 %3
          technicnormallite_set_senser_setting: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'technicnormallite_dropdown_setting_sensor_key'
              }, null],
              type: 'technicnormallite_set_senser_setting'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_setting',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM0'));
              var value = Entry.ProboTechnicNormalLite.getSettingSensorValue(script.getStringValue('PARAM1'));
              var sensorSet = Entry.ProboTechnicNormalLite.SenserSet;
              sensorSet[key] = value;
              Entry.ProboTechnicNormalLite.RemoteData.ASET2 = (sensorSet.AA1 << 4 | sensorSet.AA2) & 0xFF;
              Entry.ProboTechnicNormalLite.RemoteData.ASET1 = (sensorSet.AA3 << 4 | sensorSet.AA4) & 0xFF;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_sensor_setting(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          ///========================================================================================
          /// Input block
          ///========================================================================================
          // 리모컨 입력 %1
          technicnormallite_is_remote_key: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_remote_key'
              }],
              type: 'technicnormallite_is_remote_key'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getRemoteKey(script.getStringValue('PARAM0'));
              return Entry.ProboTechnicNormalLite.InputData.Remote[key] === 1;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.is_remote_key(%1)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 디지털 입력 %1
          technicnormallite_is_digital_value: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_digital_key'
              }],
              type: 'technicnormallite_is_digital_value'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getDigitalKey(script.getStringValue('PARAM0'));
              return Entry.ProboTechnicNormalLite.getDigitalStateValue(key);
              ;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.is_digital_value(%1)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 아날로그 입력 %1
          technicnormallite_get_analog_value: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }],
              type: 'technicnormallite_get_analog_value'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM0'));
              return Entry.ProboTechnicNormalLite.SenserSet[key] === 5 // 5: 압력
              ? 255 - Entry.ProboTechnicNormalLite.InputData.Analog[key] : Entry.ProboTechnicNormalLite.InputData.Analog[key];
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_analog_value(%1)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 3가속도 %1의 X축
          technicnormallite_get_tri_axis_acceler_x: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }],
              type: 'technicnormallite_get_tri_axis_acceler_x'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAxisKey(script.getStringValue('PARAM0'), "X");
              var value = Entry.ProboTechnicNormalLite.InputData.Acceler[key];
              return value & 0x80 ? Number((value - 255) / 10).toFixed(1) : Number(value / 10).toFixed(1);
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_tri_axis_acceler_x(%1)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 3가속도 %1의 Y축
          technicnormallite_get_tri_axis_acceler_y: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }],
              type: 'technicnormallite_get_tri_axis_acceler_y'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAxisKey(script.getStringValue('PARAM0'), "Y");
              var value = Entry.ProboTechnicNormalLite.InputData.Acceler[key];
              return value & 0x80 ? Number((value - 255) / 10).toFixed(1) : Number(value / 10).toFixed(1);
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_tri_axis_acceler_y(%1)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 3가속도 %1의 Z축
          technicnormallite_get_tri_axis_acceler_z: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }],
              type: 'technicnormallite_get_tri_axis_acceler_z'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAxisKey(script.getStringValue('PARAM0'), "Z");
              var value = Entry.ProboTechnicNormalLite.InputData.Acceler[key];
              return value & 0x80 ? Number((value - 255) / 10).toFixed(1) : Number(value / 10).toFixed(1);
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_tri_axis_acceler_z(%1)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 의 %2 ~ %3 값을 %4 ~ %5 (으)로 변환
          technicnormallite_get_value_mapping: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'number',
                params: [0]
              }, {
                type: 'number',
                params: [255]
              }, {
                type: 'number',
                params: [0]
              }, {
                type: 'number',
                params: [100]
              }],
              type: 'technicnormallite_get_value_mapping'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1,
              PARAM2: 2,
              PARAM3: 3,
              PARAM4: 4
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM0'));
              var inMin = script.getNumberValue('PARAM1');
              var inMax = script.getNumberValue('PARAM2');
              var outMin = script.getNumberValue('PARAM3');
              var outMax = script.getNumberValue('PARAM4');
              var data = Entry.ProboTechnicNormalLite.SenserSet[key] === 5 // 5: 압력
              ? 255 - Entry.ProboTechnicNormalLite.InputData.Analog[key] : Entry.ProboTechnicNormalLite.InputData.Analog[key];
              return (data - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_value_mapping(%1, %2, %3, %4, %5)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 컬러 센서 %1 이(가) %2 인가?
          technicnormallite_is_color_value: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }, {
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'technicnormallite_dropdown_sensor_color_key'
              }],
              type: 'technicnormallite_is_color_value'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key0 = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM0'));
              var key1 = Entry.ProboTechnicNormalLite.getColorSensorKey(script.getStringValue('PARAM1'));
              var value = Entry.ProboTechnicNormalLite.InputData.Analog[key0];
              var color = Entry.ProboTechnicNormalLite.Color;
              return color[key1].Min <= value && value <= color[key1].Max;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.is_color_value(%1, %2)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 컬러 센서 %1 의 색상
          technicnormallite_get_color_value: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string',
              defaultType: 'number'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }],
              type: 'technicnormallite_get_color_value'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key0 = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM0'));
              var value = Entry.ProboTechnicNormalLite.InputData.Analog[key0];
              var color = Entry.ProboTechnicNormalLite.Color;
              for (var i = 1; i < 7; i++) {
                var key1 = Entry.ProboTechnicNormalLite.getColorSensorKey(i.toString());
                if (color[key1].Min <= value && value <= color[key1].Max) {
                  switch (i) {
                    case 1:
                      return Lang.template.technicnormallite_item_color_red;
                    case 2:
                      return Lang.template.technicnormallite_item_color_green;
                    case 3:
                      return Lang.template.technicnormallite_item_color_blue;
                    case 4:
                      return Lang.template.technicnormallite_item_color_yellow;
                    case 5:
                      return Lang.template.technicnormallite_item_color_black;
                    case 6:
                      return Lang.template.technicnormallite_item_color_white;
                    default:
                      return Lang.template.technicnormallite_item_error;
                  }
                }
              }
              return Lang.template.technicnormallite_item_nothing;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_color_value(%1)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 센서 %2 을 %3 값으로 정하기 %4
          technicnormallite_set_infinite_setting: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_inNcom_sensor_key'
              }, {
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'number',
                params: [0]
              }, null],
              type: 'technicnormallite_set_infinite_setting'
            },
            paramsKeyMap: {
              //PARAM0: 0, // 0을 쓰지 않음
              PARAM1: 1,
              PARAM2: 2
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM1'));
              var count = 0;
              var value = script.getNumberValue('PARAM2');
              if (value != 0) {
                count = Math.floor(value / 255);
                value = value % 255;
              } else {
                count = 0;
                value = 0;
              }
              Entry.ProboTechnicNormalLite.Infinite.Buff[key] = Entry.ProboTechnicNormalLite.InputData.Analog[key];
              Entry.ProboTechnicNormalLite.Infinite.Start[key] = Entry.ProboTechnicNormalLite.InputData.Analog[key] - value;
              Entry.ProboTechnicNormalLite.Infinite.Count[key] = count;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_infinite_setting(%1, %2, %3)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 센서 %2 지름 %3 의 mm 값
          technicnormallite_get_infinite_mm_diameter: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_inNcom_sensor_key'
              }, {
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'number',
                params: [53.5]
              }],
              type: 'technicnormallite_get_infinite_mm_diameter'
            },
            paramsKeyMap: {
              //PARAM0: 0, // 0을 쓰지 않음
              PARAM1: 1,
              PARAM2: 2
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM1'));
              var radius = script.getNumberValue('PARAM2') / 2;
              var pi = 3.141592;
              var infinite = Entry.ProboTechnicNormalLite.Infinite;
              var value = Entry.ProboTechnicNormalLite.InputData.Analog[key];
              if (value < infinite.Buff[key] - 150) {
                infinite.Count[key]++;
              } else if (value > infinite.Buff[key] + 150) {
                infinite.Count[key]--;
              }
              infinite.Buff[key] = value;
              value = infinite.Buff[key] - infinite.Start[key] + infinite.Count[key] * 255;
              return Number(2 * pi * radius / 255 * value).toFixed(3);
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_infinite_mm_diameter(%1, %2, %3)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 센서 %2 의  %3
          technicnormallite_get_infinite_transform_input: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_inNcom_sensor_key'
              }, {
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'technicnormallite_dropdown_sensor_angle_key'
              }],
              type: 'technicnormallite_get_infinite_transform_input'
            },
            paramsKeyMap: {
              //PARAM0: 0, // 0을 쓰지 않음
              PARAM1: 1,
              PARAM2: 2
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key1 = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM1'));
              var key2 = Entry.ProboTechnicNormalLite.getSensorAngleKey(script.getStringValue('PARAM2'));
              var anlogValue = Entry.ProboTechnicNormalLite.InputData.Analog[key1];
              var infinite = Entry.ProboTechnicNormalLite.Infinite;
              if (anlogValue < infinite.Buff[key1] - 150) {
                infinite.Count[key1]++;
              } else if (anlogValue > infinite.Buff[key1] + 150) {
                infinite.Count[key1]--;
              }
              infinite.Buff[key1] = anlogValue;
              var value = infinite.Buff[key1] - infinite.Start[key1] + infinite.Count[key1] * 255;
              switch (key2) {
                case 'IS1':
                  return value;
                case 'IS2':
                  return value > 0 ? Math.floor(value % 255 * 1.41732) : Math.ceil(value % 255 * 1.41732);
                case 'IS3':
                  return Number(360 / 255 * anlogValue).toFixed(0);
                case 'IS4':
                  return value > 0 ? Math.floor(value / 255) : Math.ceil(value / 255);
                default:
                  return Lang.template.technicnormallite_item_nothing;
              }
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_infinite_transform_input(%1, %2, %3)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 멀티키 센서 %1의 %2
          technicnormallite_is_multi_sensor: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'technicnormallite_dropdown_multikey_key'
              }],
              type: 'technicnormallite_is_multi_sensor'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM0'));
              var value = Entry.ProboTechnicNormalLite.getMultiKeyValue(script.getStringValue('PARAM1'));
              return Entry.ProboTechnicNormalLite.InputData.Analog[key] >> value & 0x01;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.is_multi_sensor(%1, %2)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 분배 스위치 %1의 %2
          technicnormallite_is_multi_switch: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'technicnormallite_dropdown_multikey_key'
              }],
              type: 'technicnormallite_is_multi_switch'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key0 = Entry.ProboTechnicNormalLite.getAnalogKey(script.getStringValue('PARAM0'));
              var value = Entry.ProboTechnicNormalLite.getMultiKeyValue(script.getStringValue('PARAM1'));
              var analog = Entry.ProboTechnicNormalLite.InputData.Analog[key0];
              var multySwitch = Entry.ProboTechnicNormalLite.MultiSwitch;
              for (var i = 0; i < 8; i++) {
                var key = 'Key' + (i + 1).toString();
                if (multySwitch[key].Min <= analog && analog <= multySwitch[key].Max) {
                  return value === i;
                }
              }
              return false;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.is_multi_switch(%1, %2)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 확장 디지털 입력 %1 의 %2
          technicnormallite_is_extension_digital_input: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_boolean_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'technicnormallite_dropdown_extension_digital_key'
              }],
              type: 'technicnormallite_is_extension_digital_input'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAxisKey(script.getStringValue('PARAM0'), 'X');
              var shift = Entry.ProboTechnicNormalLite.getExtentionDigitalValue(script.getStringValue('PARAM1'));
              var value = Entry.ProboTechnicNormalLite.InputData.Acceler[key];
              return value >> shift === 1;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.is_extension_digital_input(%1, %2)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 확장 아날로그 입력 %1 의 %2
          technicnormallite_get_extension_analog_input: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_analog_key'
              }, {
                type: 'technicnormallite_dropdown_extension_analog_key'
              }],
              type: 'technicnormallite_get_extension_analog_input'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getAxisKey(script.getStringValue('PARAM0'), Entry.ProboTechnicNormalLite.getExtentionAnalogKey(script.getStringValue('PARAM1')));
              var value = Entry.ProboTechnicNormalLite.InputData.Acceler[key];
              return value;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_extension_analog_input(%1, %2)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // EEPROM %1 주소의 값 호출하기 %2
          technicnormallite_set_eeprom_call: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'number',
                params: ['0']
              }, null],
              type: 'technicnormallite_set_eeprom_call'
            },
            paramsKeyMap: {
              ADDRESS: 0
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var address = script.getNumberValue('ADDRESS', script);
              if (!script.isStart) {
                script.isStart = true;
                script.timeFlag = 1;
                var ms = 50;
                var fps = Entry.FPS || 60;
                Entry.ProboTechnicNormalLite.EEPROM.Count = Entry.ProboTechnicNormalLite.InputData.EEPROM.EC;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR4'] = 0x40;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR3'] = address;
                Entry.TimeWaitManager.add(script.block.id, function () {
                  script.timeFlag = 0;
                }, 60 / fps * ms);
                return script;
              } else if (script.timeFlag == 1) {
                return script;
              } else {
                Entry.ProboTechnicNormalLite.EEPROM.Buff = (Entry.ProboTechnicNormalLite.InputData.EEPROM.EEPR2 << 8) + Entry.ProboTechnicNormalLite.InputData.EEPROM.EEPR1;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR4'] = 0;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR3'] = 0;
                delete script.timeFlag;
                delete script.isStart;
                Entry.engine.isContinue = false;
                return script.callReturn();
              }
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_eeprom_call(%1)',
                blockType: 'param',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // EEPROM 주소의 값
          technicnormallite_get_eeprom_address_value: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic_string_field',
            statements: [],
            params: [],
            events: {},
            def: {
              type: 'technicnormallite_get_eeprom_address_value'
            },
            "class": 'technicnormallite_input',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var count = Entry.ProboTechnicNormalLite.EEPROM.Count;
              return Entry.ProboTechnicNormalLite.InputData.EEPROM.EC != count ? Entry.ProboTechnicNormalLite.EEPROM.Buff : 0;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.get_eeprom_address_value',
                blockType: 'param',
                textParams: [null]
              }]
            }
          },
          ///========================================================================================
          /// output block
          ///========================================================================================
          // DC 모터 %1 을(를) %2 속도로 회전 %3
          technicnormallite_set_dc_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_dc_1_all_key'
              }, {
                type: 'technicnormallite_dropdown_velocity_key'
              }, null],
              type: 'technicnormallite_set_dc_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getDckey(script.getStringValue('PARAM0'));
              var value = script.getNumberValue('PARAM1');
              switch (key) {
                case 'DC5':
                  Entry.ProboTechnicNormalLite.RemoteData['DC1'] = value;
                  Entry.ProboTechnicNormalLite.RemoteData['DC2'] = value;
                  break;
                case 'DC6':
                  Entry.ProboTechnicNormalLite.RemoteData['DC3'] = value;
                  Entry.ProboTechnicNormalLite.RemoteData['DC4'] = value;
                  break;
                case 'DC7':
                  Entry.ProboTechnicNormalLite.RemoteData['DC1'] = value;
                  Entry.ProboTechnicNormalLite.RemoteData['DC2'] = value;
                  Entry.ProboTechnicNormalLite.RemoteData['DC3'] = value;
                  Entry.ProboTechnicNormalLite.RemoteData['DC4'] = value;
                  break;
                default:
                  Entry.ProboTechnicNormalLite.RemoteData[key] = value;
                  break;
              }
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_dc_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 서보 모터 %1 의 위치를 %2 로 이동 %3
          technicnormallite_set_servo_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_port_1_4_key'
              }, {
                type: 'technicnormallite_dropdown_servo_position_key'
              }, null],
              type: 'technicnormallite_set_servo_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getServoKey(script.getStringValue('PARAM0'));
              var value = script.getNumberValue('PARAM1');
              Entry.ProboTechnicNormalLite.RemoteData[key] = Math.min(Math.max(value, 0), 100);
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_servo_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // S 모터 %1 을(를) %2 속도로 회전 %3
          technicnormallite_set_s_dc_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_port_1_4_key'
              }, {
                type: 'technicnormallite_dropdown_velocity_key'
              }, null],
              type: 'technicnormallite_set_s_dc_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getServoKey(script.getStringValue('PARAM0'));
              var speed = script.getNumberValue('PARAM1');
              var value = Math.min(Math.max(speed, -20), 20) + 148;
              switch (key) {
                case 'Servo5':
                  Entry.ProboTechnicNormalLite.RemoteData['Servo1'] = value;
                  Entry.ProboTechnicNormalLite.RemoteData['Servo2'] = value;
                  break;
                case 'Servo6':
                  Entry.ProboTechnicNormalLite.RemoteData['Servo3'] = value;
                  Entry.ProboTechnicNormalLite.RemoteData['Servo4'] = value;
                  break;
                default:
                  Entry.ProboTechnicNormalLite.RemoteData[key] = value;
                  break;
              }
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_s_dc_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 출력핀 %1 을(를) %2 %3
          technicnormallite_set_port_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_port_1_4_key'
              }, {
                type: 'technicnormallite_dropdown_on_off_key'
              }, null],
              type: 'technicnormallite_set_port_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getPortKey(script.getStringValue('PARAM0'));
              var value = Entry.ProboTechnicNormalLite.getPortToggleValue(script.getStringValue('PARAM1'));
              Entry.ProboTechnicNormalLite.RemoteData[key] = value;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_port_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 을(를) %2 음표로 연주하기 %3
          technicnormallite_play_melody_note_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_pitch_key'
              }, {
                type: 'technicnormallite_dropdown_note_key'
              }, null],
              type: 'technicnormallite_play_melody_note_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              if (!script.isStart) {
                script.isStart = true;
                script.timeFlag = 1;
                var pitch = Entry.ProboTechnicNormalLite.getPitchValue(script.getNumberValue('PARAM0'));
                var note = Entry.ProboTechnicNormalLite.getNoteKey(script.getStringValue('PARAM1'));
                var ms = Entry.ProboTechnicNormalLite.Note[note];
                var fps = Entry.FPS || 60;
                Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = pitch >> 8;
                Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = pitch;
                Entry.TimeWaitManager.add(script.block.id, function () {
                  script.timeFlag = 0;
                }, 60 / fps * ms);
                return script;
              } else if (script.timeFlag == 1) {
                return script;
              } else {
                Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = 0;
                Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = 0;
                delete script.timeFlag;
                delete script.isStart;
                Entry.engine.isContinue = false;
                return script.callReturn();
              }
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.play_melody_note_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 을(를) %2 초 동안 연주하기 %3
          technicnormallite_play_melody_sec_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_pitch_key'
              }, {
                type: 'technicnormallite_dropdown_time_1_key'
              }, null],
              type: 'technicnormallite_play_melody_sec_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              if (!script.isStart) {
                script.isStart = true;
                script.timeFlag = 1;
                var pitch = Entry.ProboTechnicNormalLite.getPitchValue(script.getNumberValue('PARAM0'));
                var sec = script.getNumberValue('PARAM1');
                var fps = Entry.FPS || 60;
                Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = pitch >> 8;
                Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = pitch;
                Entry.TimeWaitManager.add(script.block.id, function () {
                  script.timeFlag = 0;
                }, 60 / fps * sec * 1000);
                return script;
              } else if (script.timeFlag == 1) {
                return script;
              } else {
                Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = 0;
                Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = 0;
                delete script.timeFlag;
                delete script.isStart;
                Entry.engine.isContinue = false;
                return script.callReturn();
              }
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.play_melody_sec_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 을(를) 연주하기 %2
          technicnormallite_play_melody_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_pitch_key'
              }, null],
              type: 'technicnormallite_play_melody_output'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var pitch = Entry.ProboTechnicNormalLite.getPitchValue(script.getNumberValue('PARAM0'));
              Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = pitch >> 8;
              Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = pitch;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.play_melody_output(%1)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 값을(를) %2 초 동안 연주하기 %3
          technicnormallite_play_value_sec_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'number',
                params: [35391]
              }, {
                type: 'technicnormallite_dropdown_time_1_key'
              }, null],
              type: 'technicnormallite_play_value_sec_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              if (!script.isStart) {
                script.isStart = true;
                script.timeFlag = 1;
                var melody = script.getNumberValue('PARAM0');
                var sec = script.getNumberValue('PARAM1');
                var fps = Entry.FPS || 60;
                Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = melody >> 8 & 0xff;
                Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = melody & 0xff;
                Entry.TimeWaitManager.add(script.block.id, function () {
                  script.timeFlag = 0;
                }, 60 / fps * sec * 1000);
                return script;
              } else if (script.timeFlag == 1) {
                return script;
              } else {
                Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = 0;
                Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = 0;
                delete script.timeFlag;
                delete script.isStart;
                Entry.engine.isContinue = false;
                return script.callReturn();
              }
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.play_melody_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 1 값을(를) 연주하기 %2
          technicnormallite_play_value_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'number',
                params: [35391]
              }, null],
              type: 'technicnormallite_play_value_output'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var melody = script.getNumberValue('PARAM0');
              Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = melody >> 8 & 0xff;
              Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = melody & 0xff;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.play_melody_output(%1)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // %1 을(를) %2초 간격으로 재생하기 %3
          technicnormallite_play_melody_track_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_melody_key'
              }, {
                type: 'technicnormallite_dropdown_time_2_key'
              }, null],
              type: 'technicnormallite_play_melody_track_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              function getTrackStep(track, script) {
                if (!script.isStart) {
                  script.isStart = true;
                  script.trackStep = 0;
                } else {
                  script.trackStep++;
                }
                var sec = script.getNumberValue('PARAM1');
                var fps = Entry.FPS || 60;
                var melody = Entry.ProboTechnicNormalLite.Track[track][script.trackStep];
                Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = melody >> 8 & 0xff;
                Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = melody & 0xff;
                script.timeFlag = 1;
                Entry.TimeWaitManager.add(script.block.id, function () {
                  script.timeFlag = 0;
                }, 60 / fps * sec * 1000);
              }
              var TR = Entry.ProboTechnicNormalLite.getMelodyValue(script.getStringValue('PARAM0'));
              if (!script.isStart) {
                switch (TR) {
                  case 0:
                    script.maxStep = 6;
                    break;
                  case 1:
                    script.maxStep = 7;
                    break;
                  case 2:
                    script.maxStep = 3;
                    break;
                  case 3:
                    script.maxStep = 3;
                    break;
                }
                getTrackStep(TR, script);
                return script;
              } else if (script.timeFlag == 1) {
                return script;
              } else if (script.trackStep < script.maxStep) {
                getTrackStep(TR, script);
                return script;
              } else {
                Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = 0;
                Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = 0;
                delete script.trackStep;
                delete script.maxStep;
                delete script.timeFlag;
                delete script.isStart;
                Entry.engine.isContinue = false;
                return script.callReturn();
              }
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.play_melody_track_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // 멜로디 중지 %1
          technicnormallite_play_melody_off: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'technicnormallite_play_melody_off'
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              Entry.ProboTechnicNormalLite.RemoteData['MEL2'] = 0;
              Entry.ProboTechnicNormalLite.RemoteData['MEL1'] = 0;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.play_melody_track_output',
                textParams: [null]
              }]
            }
          },
          // RGB LED %1 을(를) %2 으로 켜기 %3
          technicnormallite_set_rgbled_on_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_port_1_4_key'
              }, {
                type: 'technicnormallite_dropdown_rgb_color_key'
              }, null],
              type: 'technicnormallite_set_rgbled_on_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getServoKey(script.getStringValue('PARAM0'));
              var value = Entry.ProboTechnicNormalLite.getRgbToggleValue(script.getStringValue('PARAM1'));
              Entry.ProboTechnicNormalLite.RemoteData[key] = value;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_rgbled_on_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // RGB LED %1 을(를) 끄기 %2
          technicnormallite_set_rgbled_off_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_port_1_4_key'
              }, null],
              type: 'technicnormallite_set_rgbled_off_output'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getServoKey(script.getStringValue('PARAM0'));
              var value = Entry.ProboTechnicNormalLite.getRgbToggleValue('0');
              Entry.ProboTechnicNormalLite.RemoteData[key] = value;
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_rgbled_off_output(%1)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // RGB LED %1 %2 으로 %3 초 간격 %4
          technicnormallite_set_rgbled_flashing_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_port_1_4_key'
              }, {
                type: 'technicnormallite_dropdown_rgb_color_key'
              }, {
                type: 'technicnormallite_dropdown_time_3'
              }, null],
              type: 'technicnormallite_set_rgbled_flashing_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1,
              PARAM2: 2
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getServoKey(script.getStringValue('PARAM0'));
              var value = Entry.ProboTechnicNormalLite.getRgbTwinkleValue(script.getStringValue('PARAM1'), script.getNumberValue('PARAM2'));
              Entry.ProboTechnicNormalLite.RemoteData[key] = value;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_rgbled_flashing_output(%1, %2, %3)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // RGB LED %1 을(를) %2 으로 디밍 %3
          technicnormallite_set_rgbled_dimming_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'technicnormallite_dropdown_port_1_4_key'
              }, {
                type: 'technicnormallite_dropdown_rgb_color_key'
              }, null],
              type: 'technicnormallite_set_rgbled_dimming_output'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var key = Entry.ProboTechnicNormalLite.getServoKey(script.getStringValue('PARAM0'));
              var color = Entry.ProboTechnicNormalLite.getRgbDimmingValue(script.getStringValue('PARAM1'));
              Entry.ProboTechnicNormalLite.RemoteData[key] = color;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_rgbled_dimming_output(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // FND를 %1 (으)로 설정 %2
          technicnormallite_set_fnd_output: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'number',
                params: [0]
              }, null],
              type: 'technicnormallite_set_fnd_output'
            },
            paramsKeyMap: {
              PARAM0: 0
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var value = script.getNumberValue('PARAM0');
              Entry.ProboTechnicNormalLite.RemoteData['FND'] = value;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_fnd_output(%1)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          },
          // FND 끄기 %1
          technicnormallite_set_fnd_off: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [null],
              type: 'technicnormallite_set_fnd_off'
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              Entry.ProboTechnicNormalLite.RemoteData['FND'] = 100;
              return script.callReturn();
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_fnd_off',
                textParams: [null]
              }]
            }
          },
          // EEPROM %1 주소에 %2 값 설정하기 %3
          technicnormallite_set_eeprom_write: {
            color: EntryStatic.colorSet.block["default"].HARDWARE,
            outerLine: EntryStatic.colorSet.block.darken.HARDWARE,
            fontColor: '#fff',
            skeleton: 'basic',
            statements: [],
            params: [{
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Block',
              accept: 'string'
            }, {
              type: 'Indicator',
              img: 'block_icon/hardwarelite_icon.svg',
              size: 12
            }],
            events: {},
            def: {
              params: [{
                type: 'number',
                params: [0]
              }, {
                type: 'number',
                params: [0]
              }, null],
              type: 'technicnormallite_set_eeprom_write'
            },
            paramsKeyMap: {
              PARAM0: 0,
              PARAM1: 1
            },
            "class": 'technicnormallite_output',
            isNotFor: ['ProboTechnicNormalLite'],
            func: function func(sprite, script) {
              var address = script.getNumberValue('PARAM0');
              var value = script.getNumberValue('PARAM1');
              if (!script.isStart) {
                script.isStart = true;
                script.timeFlag = 1;
                var ms = 50;
                var fps = Entry.FPS || 60;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR4'] = 0x80;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR3'] = address;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR2'] = value >> 8 & 0xff;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR1'] = value & 0xff;
                Entry.TimeWaitManager.add(script.block.id, function () {
                  script.timeFlag = 0;
                }, 60 / fps * ms);
                return script;
              } else if (script.timeFlag == 1) {
                return script;
              } else {
                Entry.ProboTechnicNormalLite.RemoteData['EEPR4'] = 0x40;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR3'] = address;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR2'] = 0;
                Entry.ProboTechnicNormalLite.RemoteData['EEPR1'] = 0;
                setTimeout(function () {
                  Entry.ProboTechnicNormalLite.RemoteData['EEPR4'] = 0;
                  Entry.ProboTechnicNormalLite.RemoteData['EEPR3'] = 0;
                  Entry.ProboTechnicNormalLite.RemoteData['EEPR2'] = 0;
                  Entry.ProboTechnicNormalLite.RemoteData['EEPR1'] = 0;
                }, 100);
                delete script.timeFlag;
                delete script.isStart;
                Entry.engine.isContinue = false;
                return script.callReturn();
              }
            },
            syntax: {
              js: [],
              py: [{
                syntax: 'ProboTechnicNormalLite.set_eeprom_write(%1, %2)',
                textParams: [{
                  type: 'Block',
                  accept: 'string'
                }, {
                  type: 'Block',
                  accept: 'string'
                }]
              }]
            }
          }
        }; // getBlock() return;
      }
    }]);
  }())();
})();
module.exports = Entry.ProboTechnicNormalLite;